import Firebase from "firebase/app";
import { firestore, functions, storage } from "../Firebase";
import {
  setBranchUsersList,
  setCompleted,
  setContacts,
  setRefreshContacts,
  setTotal,
  showSnackbarAction,
  setFilterObject
} from "../Redux/actions";
import {
  phoneValidate,
  validateNumber,
} from "../Values/validatorsnew";
import * as XLSX from "xlsx";
import { datesField, stageList } from "../Values/tables";
import moment from "moment";
import {
  CallbackValidation,
  FreshLeadValidation,
  InterestedLeadValidation,
  LostLeadValidation,
  NotInterestedValidation,
  WonValidation,
} from "./validation";
import {
  chunk,
  getGraceDateForPastApproval,
  properFormat,
  timer,
  uploadFileToS3
} from "../Values/utils";
import axios from "axios";
import {url} from "../../src/Values/constants";
import { useGridNativeEventListener } from "@mui/x-data-grid";
import { sendNotification } from "./notification";
import axiosHandler from "./axiosHandler";
import { triggerWhatsappDispositionMessage } from "./marketingAutomation";

export const createContacts = async (
  organization_id: string,
  email: string,
  first_name: string,
  last_name: string,
  contact_no: any,
  created_by: string,
  uid: string,
  dispatcher: any,
  history: any,
  user_email: any,
  alternate_no: any,
  country_code: string,
  setLoad: (data: boolean) => any,
  country: string,
  property_type: string,
  property_stage: string,
  lead_type: string,
  location: string,
  budget: string,
  project: string,
  property_sub_type: string,
  leadSource: string,
  addSet:string,
  campaign:string,
  notes: string,
  is_button_called: boolean,
  userEmail?: string,
  gender?: string,
  marital_status?: any,
  dob?: any,
  anniversary?: any,
  cusAdd?: any,
  businessVertical?:any
) => {
  //   console.log("gender_form",gender)
  // console.log("marital_status_form",marital_status)
  // console.log("dob_form",dob)
  // console.log("anniversary_form",anniversary,)
  // console.log("cusAdd_form",cusAdd)
  var currentTime = new Date();
  let ab;
  let ad;
  if(dob){
    let Birth_date = new Date(dob)
    Birth_date.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
    ab =Firebase.firestore.Timestamp.fromDate(Birth_date)
  }
  if(anniversary){
    let AnniversaryDate = new Date(anniversary)
    AnniversaryDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
    ad =Firebase.firestore.Timestamp.fromDate(AnniversaryDate)
  }
  try {
    let result = false;
    if (alternate_no !== "") { 
      const res = await functions.httpsCallable(
        "checkLead"
      )(
        JSON.stringify({
          organization_id: organization_id,
          contactList: [contact_no, alternate_no],
        })
      );
      result = res.data;
    } else {
      const res = await functions.httpsCallable(
        "checkLead"
      )(
        JSON.stringify({
          organization_id: organization_id,
          contact_no: contact_no,
        })
      );
      result = res.data;
    }

    let check = true;

    if (result === false) {
      dispatcher(
        showSnackbarAction(
          // "This Contact Number Already Exists",
          "Contact number or Alternate number already exists on another lead",
          "warning"
        )
      );
      setLoad && setLoad(false);
    } else {
      if (check === true) {
        const contactDoc = firestore
          .collection("contacts")
          .doc();
        contactDoc
          .set({
            alternate_no: alternate_no,
            organization_id: organization_id,
            associate_status: true,
            budget: budget,
            contact_no: validateNumber({
              contact_no,
              country,
            }).contact_no,
            country_code: country_code,
            created_at: Firebase.firestore.Timestamp.now(),
            created_by: created_by,
            customer_image: "",
            customer_name: first_name + " " + last_name,
            email: email.toLowerCase(),
            lead_source: leadSource,
            lead_assign_time:
              Firebase.firestore.Timestamp.now(),
            location: location,
            lost_reason: "",
            modified_at: Firebase.firestore.Timestamp.now(),
            not_int_reason: "",
            other_not_int_reason: "",
            other_lost_reason: "",
            previous_owner: "",
            project: project,
            property_stage: property_stage,
            property_type: property_type,
            property_sub_type: property_sub_type,
            source_status: true,
            stage: "FRESH",
            transfer_status: false,
            uid: uid,
            lead_type:lead_type,
            contact_owner_email: user_email.toLowerCase(),
            feedback_time: "",
            next_follow_up_type: "",
            next_follow_up_date_time: "",
            is_button_called: false,
            addset:addSet,
            campaign:campaign,
            gender:gender,
            marital_status:marital_status,
            dob:ab ? ab : "",
            anniversary_date:ad ? ad : "",
            address:cusAdd,
            business_vertical:businessVertical
          })
          .then(() => {
            functions.httpsCallable("sendNotifications")(
              JSON.stringify({
                organization_id: organization_id,
                notifications: { [uid]: 1 },
              })
            );
            if (notes !== "") {
              firestore
                .collection("contactResources")
                .doc(contactDoc.id)
                .set({
                  notes: [
                    {
                      note: notes,
                      userEmail: userEmail,
                      created_at:
                        Firebase.firestore.Timestamp.now(),
                    },
                  ],
                });
            }

            dispatcher(
              showSnackbarAction(
                "Contact Created!!",
                "success"
              )
            );
            setLoad(false);

            history.replace("/");
            setTimeout(() => {
              dispatcher(setRefreshContacts(true));
            }, 2500);
          })
          .catch((error) => {
            console.log("Firestore Contacts error", error);
            setLoad(false);
          });
      } else {
        console.log("Firestore Contacts error");
        dispatcher(
          showSnackbarAction("Error!! Try Again!!", "error")
        );
        setLoad(false);
      }
    }
  } catch (error) {
    console.log(error);
  }
};

const sortContacts = (a: any, b: any) => {
  if (a.created_at.toDate() > b.created_at.toDate()) {
    return -1;
  } else {
    return 1;
  }
};

// fetchDrillDownAllContacts is not being used anywhere
export const fetchDrillDownAllContacts = (
  organization_id: string,
  stage: string,
  dispatcher: any
) => {
  firestore
    .collection("contacts")
    .where("organization_id", "==", organization_id)
    .where("stage", "==", stage)
    .get()
    .then((contact) => {
      const data: any[] = [];
      if (contact) {
        contact.forEach((contact) => {
          data.push({
            ...contact.data(),
            contactId: contact.id,
            contact_owner_email: contact
              .data()
              .contact_owner_email.toLowerCase(),
          });
        });
        dispatcher(
          setContacts({ [stage]: data.sort(sortContacts) })
        );
      } else {
        console.log("org not found");
      }
    });
};

// fetchTeamLeadContacts is not being used anywhere
export const fetchTeamLeadContacts = (
  setContacts: (data: any[]) => void,
  uidList: any[]
) => {
  const subscriber = firestore
    .collection("contacts")
    .where("uid", "in", uidList)
    .onSnapshot((contact) => {
      const data: any[] = [];
      if (contact) {
        contact.forEach((contact) => {
          data.push({
            ...contact.data(),
            contactId: contact.id,
            contact_owner_email: contact
              .data()
              .contact_owner_email.toLowerCase(),
          });
        });
        setContacts(data.sort(sortContacts));
      } else {
        console.log("Team Lead Error");
      }
    });
  return subscriber;
};

// fetchLeadSources is not being used anywhere
export const fetchLeadSources = (
  setLeadSource: (data: any[]) => void,
  organization_id: string
) => {
  const subscriber = firestore
    .collection("organizationResources")
    .doc(organization_id)
    .onSnapshot((resources) => {
      if (resources) {
        const resourceData = resources.data();

        if (resourceData?.leadSources) {
          setLeadSource(resourceData?.leadSources);
        } else {
          setLeadSource([]);
        }
      } else {
        console.log("Org not found");
      }
    });
  return subscriber;
};

const checkLeadSource = (
  leadSourceList: any[],
  leadSource: any[],
  dispatcher: any
) => {
  let count = 0;

  leadSourceList.forEach((item: any) => {
    if (leadSource.includes(item.leadSource)) {
    } else {
      dispatcher(
        showSnackbarAction(
          "Lead Source At " +
          item.sno +
          " does not exists!!",
          "error"
        )
      );
      count = count + 1;
    }
  });
  if (count === 0) {
    return true;
  } else {
    return false;
  }
};

// mapContactsTemplate is not being used anywhere
export const mapContactsTemplate = (
  data: { [key: string]: any }[],
  map: { [key: string]: string },
  organization_id: string,
  dispatcher: any,
  submit: () => void,
  usersList: any[],
  setLoad: (data: boolean) => any,
  leadSource: any[],
  name: string,
  projects: any[],
  locations: any[],
  budgets: any[],
  country: string,
  resTypes: any[],
  comTypes: any[]
) => {
  let templateList: any[] = [];
  let contactList: any[] = [];
  let notesList: any[] = [];
  let leadSourceList: any[] = [];
  let checkStage: boolean = true;
  let numberList: any[] = [];

  data.forEach((contact, index) => {
    if (checkStage === false) {
      setLoad(false);
      return;
    }
    let uid = "";
    if (map["Owner"]) {
      const userData = usersList.filter(
        (item) =>
          String(item.user_email).toLowerCase() ===
          String(contact[map["Owner"]].toLowerCase())
      );
      uid = userData.length === 0 ? "" : userData[0].uid;
      if (uid === "") {
        dispatcher(
          showSnackbarAction(
            "Please Provide The Owner For the Contact At: " +
            contact.sno,
            "error"
          )
        );

        checkStage = false;
        return;
      }
    }

    if (!map.hasOwnProperty("Customer Name")) {
      dispatcher(
        showSnackbarAction(
          "Please Select customer name",
          "error"
        )
      );
      checkStage = false;
      return;
    } else if (!map.hasOwnProperty("Mobile No.")) {
      dispatcher(
        showSnackbarAction(
          "Please Select contact number",
          "error"
        )
      );

      checkStage = false;
      return;
    } else if (!map.hasOwnProperty("Lead Source")) {
      dispatcher(
        showSnackbarAction(
          "Please Select Lead Source",
          "error"
        )
      );

      checkStage = false;

      return;
    } else if (!map.hasOwnProperty("Stage")) {
      dispatcher(
        showSnackbarAction("Please Select Stage", "error")
      );

      checkStage = false;

      return;
    } else if (!map.hasOwnProperty("Country Code")) {
      dispatcher(
        showSnackbarAction(
          "Please Select Country Code",
          "error"
        )
      );

      checkStage = false;

      return;
    } else if (contact[map["Customer Name"]] === "") {
      dispatcher(
        showSnackbarAction(
          "Invalid Customer Name at row " + contact.sno,
          "error"
        )
      );

      checkStage = false;
      return;
    } else if (contact[map["Country Code"]] === "") {
      dispatcher(
        showSnackbarAction(
          "Invalid Country Code at row " + contact.sno,
          "error"
        )
      );

      checkStage = false;
      return;
    } else if (map.hasOwnProperty("Inventory Type")) {
      if (
        contact[map["Inventory Type"]] !== "Primary" &&
        contact[map["Inventory Type"]] !== "Secondary" &&
        contact[map["Inventory Type"]] !== ""
      ) {
        dispatcher(
          showSnackbarAction(
            "Invalid Inventory Type at row " + contact.sno,
            "error"
          )
        );
        checkStage = false;
        return;
      }
    } else if (
      contact[map["Stage"]] === "" ||
      !stageList.includes(
        contact[map["Stage"]].toUpperCase()
      )
    ) {
      dispatcher(
        showSnackbarAction(
          "Invalid Stage at row " + contact.sno,
          "error"
        )
      );

      checkStage = false;
      return;
    }
    if (
      map["Stage"] &&
      contact[map["Stage"]].toUpperCase() === "INTERESTED"
    ) {

      checkStage = InterestedLeadValidation(
        map,
        dispatcher,
        contact,
        locations,
        projects,

        budgets,
        resTypes,
        comTypes
      );
    } else if (
      map["Stage"] &&
      contact[map["Stage"]].toUpperCase() === "LOST"
    ) {
      checkStage = LostLeadValidation(
        map,
        dispatcher,
        contact,
        locations,
        budgets,
        projects,
        comTypes,
        resTypes
      );
    } else if (
      map["Stage"] &&
      contact[map["Stage"]].toUpperCase() === "CALL BACK"
    ) {
      checkStage = CallbackValidation(
        map,
        dispatcher,
        contact
      );
    } else if (
      map["Stage"] &&
      contact[map["Stage"]].toUpperCase() ===
      "NOT INTERESTED"
    ) {
      checkStage = NotInterestedValidation(
        map,
        dispatcher,
        contact
      );
    } else if (
      map["Stage"] &&
      contact[map["Stage"]].toUpperCase() === "WON"
    ) {
      checkStage = WonValidation(
        map,
        dispatcher,
        contact,
        locations,
        budgets,
        projects,
        comTypes,
        resTypes
      );
    } else if (
      map["Stage"] &&
      contact[map["Stage"]].toUpperCase() === "FRESH"
    ) {
      checkStage = FreshLeadValidation(
        map,
        dispatcher,
        contact,
        locations,
        projects,
        budgets,
        resTypes,
        comTypes
      );
    } else {
      dispatcher(
        showSnackbarAction(
          "Invalid Stage at row: " + contact.sno,
          "error"
        )
      );
      checkStage = false;
    }
    if (checkStage === false) {
      return;
    }

    templateList.push({
      alternate_no: map["Alternate No."]
        ? contact[map["Alternate No."]]
          ? contact[map["Alternate No."]]
          : ""
        : "",
      organization_id: organization_id,
      associate_status: true,
      budget: map["Budget"] ? contact[map["Budget"]] : "",
      contact_no: map["Mobile No."]
        ? validateNumber({
          contact_no: contact[map["Mobile No."]],
          country,
        }).contact_no
        : "",
      country_code: map["Country Code"]
        ? contact[map["Country Code"]]
        : "",
      created_at: map["Created At"]
        ? contact[map["Created At"]] !== ""
          ? Firebase.firestore.Timestamp.fromDate(
            moment(
              contact[map["Created At"]],
              "MM/DD/YY HH:mm"
            ).toDate()
          )
          : Firebase.firestore.Timestamp.now()
        : Firebase.firestore.Timestamp.now(),
      created_by: map["Created By"]
        ? contact[map["Created By"]]
          ? contact[map["Created By"]]
          : name
        : name,
      call_back_reason: map["Call Back Reason"]
        ? contact[map["Call Back Reason"]]
        : "",
      customer_image: "",
      customer_name: map["Customer Name"]
        ? contact[map["Customer Name"]]
        : "",
      email: map["Email ID"]
        ? contact[map["Email ID"]].toLowerCase()
        : "",
      lead_source: map["Lead Source"]
        ? contact[map["Lead Source"]]
        : "",
      lead_assign_time: map["Lead Assign At"]
        ? contact[map["Lead Assign At"]] !== ""
          ? Firebase.firestore.Timestamp.fromDate(
            moment(
              contact[map["Lead Assign At"]],
              "MM/DD/YY HH:mm"
            ).toDate()
          )
          : Firebase.firestore.Timestamp.now()
        : Firebase.firestore.Timestamp.now(),
      modified_at: Firebase.firestore.Timestamp.now(),
      addset: map["Addset"]
        ? contact[map["Addset"]]
          ? contact[map["Addset"]]
          : ""
        : "",
      campaign: map["Campaign"]
        ? contact[map["Campaign"]]
          ? contact[map["Campaign"]]
          : ""
        : "",
      stage_change_at: map["Stage Change At"]
        ? contact[map["Stage Change At"]] !== ""
          ? Firebase.firestore.Timestamp.fromDate(
            moment(
              contact[map["Stage Change At"]],
              "MM/DD/YY HH:mm"
            ).toDate()
          )
          : Firebase.firestore.Timestamp.now()
        : Firebase.firestore.Timestamp.now(),
      location: map["Location"]
        ? contact[map["Location"]]
        : "",
      lost_reason: map["Lost Reason"]
        ? contact[map["Lost Reason"]]
        : "",
      not_int_reason: map["Not interested reason"]
        ? contact[map["Not interested reason"]]
        : "",
      other_not_int_reason: "",
      other_lost_reason: "",
      previous_owner: "",
      project: map["Project"]
        ? contact[map["Project"]]
        : "",
      property_stage: map["Property Stage"]
        ? properFormat(contact[map["Property Stage"]])
        : "",
      property_type: map["Property Type"]
        ? properFormat(contact[map["Property Type"]])
        : "",
      property_sub_type: map["Property Sub Type"]
        ? properFormat(contact[map["Property Sub Type"]])
        : "",
      source_status: true,
      inventory_type: map["Inventory Type"]
        ? properFormat(contact[map["Inventory Type"]])
        : "",
      stage: map["Stage"]
        ? contact[map["Stage"]].toUpperCase() ===
          "CALL BACK"
          ? "CALLBACK"
          : contact[map["Stage"]].toUpperCase()
        : "FRESH",
      transfer_status: false,
      uid: uid,
      contact_owner_email: map["Owner"]
        ? contact[map["Owner"]].toLowerCase()
        : "",
      feedback_time: "",
      next_follow_up_type: map["Next Follow Up Type"]
        ? contact[map["Next Follow Up Type"]]
        : "",
      next_follow_up_date_time: map[
        "Next Follow Up Date & Time"
      ]
        ? contact[map["Next Follow Up Date & Time"]] !== ""
          ? Firebase.firestore.Timestamp.fromDate(
            moment(
              contact[map["Next Follow Up Date & Time"]],
              "MM/DD/YY HH:mm"
            ).toDate()
          )
          : ""
        : "",
    });

    if (
      numberList.includes(
        validateNumber({
          contact_no: contact[map["Mobile No."]],
          country,
        }).contact_no
      )
    ) {
      dispatcher(
        showSnackbarAction(
          "Repeted Contact at " + contact.sno,
          "error"
        )
      );

      checkStage = false;
      return;
    } else {
      contactList.push({
        contact_no: validateNumber({
          contact_no: contact[map["Mobile No."]],
          country,
        }).contact_no,
        sno: contact.sno,
      });
      numberList.push(
        validateNumber({
          contact_no: contact[map["Mobile No."]],
          country,
        }).contact_no
      );
    }
    if (map.hasOwnProperty("Notes")) {
      notesList.push(contact[map["Notes"]]);
    }
    leadSourceList.push({
      leadSource: contact[map["Lead Source"]],
      sno: contact.sno,
    });
  });

  if (templateList.length === data.length) {
    let check = false;
    check = checkLeadSource(
      leadSourceList,
      leadSource,
      dispatcher
    );
    if (check === true) {
      createContactsFirebase(
        templateList,
        contactList,
        dispatcher,
        submit,
        (data: boolean) => setLoad(data),
        organization_id,
        notesList
      );
    } else {
      setLoad(false);
    }
  }
  if (templateList.length === 0) {
    setLoad(false);
  }
};

const createContactsFirebase = async (
  data: any[],
  contactList: any[],
  dispatcher: any,
  submit: () => void,
  setLoad: (data: boolean) => any,
  organization_id: any,
  notesList: any[]
) => {
  const contacts: string[] = [];

  contactList.forEach((item) =>
    contacts.push(item.contact_no)
  );
  const funcData = JSON.stringify({
    organization_id: organization_id,
    contact_no: contacts,
  });
  const result = await functions.httpsCallable(
    "checkMultipleLead"
  )(funcData);

  if (result.data !== true) {
    const contact = contactList.filter(
      (item) => item.contact_no === result.data
    );
    dispatcher(
      showSnackbarAction(
        result.data +
        " Contact Already Exists at " +
        contact[0].sno,
        "error"
      )
    );
    setLoad(false);
  } else {
    if (data.length > 500) {
      dispatcher(setTotal(data.length));
      const splitedData = chunk(data, 500);
      const notesData = chunk(notesList, 500);
      dispatcher(setCompleted(0));

      let total = 0;
      try {
        for (let i = 0; i < splitedData.length; i++) {
          total += splitedData[i].length;
          await createMultipleContact(
            splitedData[i],
            notesData[i]
          );

          dispatcher(setCompleted(total));
        }
        dispatcher(setTotal(0));
        sendNotifications(data, organization_id);
        dispatcher(
          showSnackbarAction(
            "Contacts Uploaded!!",
            "success"
          )
        );
        submit();
        setLoad(false);
      } catch (error) {
        console.log("Create contacts error", error);
        setLoad(false);
      }
    } else {
      createMultipleContact(data, notesList)
        .then(() => {
          sendNotifications(data, organization_id);
          dispatcher(
            showSnackbarAction(
              "Contacts Uploaded!!",
              "success"
            )
          );
          submit();
          setLoad(false);
        })
        .catch((error) => {
          console.log("Create contacts error", error);
          setLoad(false);
        });
    }
  }
};

const createMultipleContact = async (
  data: any[],
  notesList: any[]
) => {
  const batch = firestore.batch();
  const notesBatch = firestore.batch();

  data.forEach((item, index) => {
    const contactsRef = firestore
      .collection("contacts")
      .doc();
    const notesRef = firestore
      .collection("contactResources")
      .doc(contactsRef.id);
    batch.set(contactsRef, item, { merge: true });
    if (notesList !== undefined && notesList.length !== 0) {
      if (notesList[index] !== "") {
        notesBatch.set(
          notesRef,
          {
            notes: [
              {
                note: notesList[index],
                created_at:
                  Firebase.firestore.Timestamp.now(),
              },
            ],
          },
          { merge: true }
        );
      }
    }
  });
  await batch.commit();
  if (notesList !== undefined && notesList.length !== 0) {
    await notesBatch.commit();
  }
};

const sendNotifications = async (
  data: any[],
  organization_id: string
) => {
  const notificationData: { [key: string]: number } = {};
  data.forEach((item) => {
    if (item.uid !== "") {
      if (notificationData[item.uid]) {
        notificationData[item.uid] += 1;
      } else {
        notificationData[item.uid] = 1;
      }
    }
  });
  functions.httpsCallable("sendNotifications")(
    JSON.stringify({
      organization_id: organization_id,
      notifications: notificationData,
    })
  );
};

export const handleFileUpload = (
  file: any,
  setData: (data: any[]) => void,
  setColumns: (data: any[]) => void,
  setLoad: (data: boolean) => void
) => {
  setTimeout(
    () =>
      readFile(
        file,
        (data: any) => setData(data),
        (col: any) => setColumns(col)
      ),
    100
  );
  setLoad(false);
};

const readFile = (
  file: any,
  setData: (data: any[]) => void,
  setColumns: (data: any[]) => void
) => {
  const reader = new FileReader();
  reader.onload = (evt: ProgressEvent<FileReader>) => {
    /* Parse data */
    const bstr = evt?.target?.result;
    const wb = XLSX.read(bstr, { type: "binary" });
    /* Get first worksheet */
    const wsname = wb.SheetNames[0];
    const ws: any = wb.Sheets[wsname];
    /* Convert array of arrays */
    //@ts-ignore
    const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
    processData(
      data,
      (data: any) => setData(data),
      (col: any) => setColumns(col)
    );
  };
  reader.readAsBinaryString(file);
};

const processData = (
  dataString: any,
  setData: (data: any[]) => void,
  setColumns: (data: any[]) => void
) => {
  const dataStringLines = dataString.split(/\r\n|\n/);
  const headers = dataStringLines[0].split(
    /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
  );
  
  const list: any = [];
  let sno = 1;
  for (let i = 1; i < dataStringLines.length; i++) {
    const row = dataStringLines[i].split(
      /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
    );
    if (headers && row.length === headers.length) {
      let obj: any = {};
      for (let j = 0; j < headers.length; j++) {
        let d = row[j];
        if (d.length > 0) {
          if (d[0] === '"')
            d = d.substring(1, d.length - 1);
          if (d[d.length - 1] === '"')
            d = d.substring(d.length - 2, 1);
        }
        d.trim()
        if (headers[j]) {
          obj[headers[j]] = d;
        }
      }

      // remove the blank rows
      if (Object.values(obj).filter((x) => x).length > 0) {
        obj = { ...obj, sno };
        list.push(obj);
        sno = sno + 1;
      }
    }
  }

  // prepare columns list from headers
  const columns = headers.map((c: any) => ({
    name: c,
    selector: c,
  }));

  setData(list);
  setColumns(columns);
};

// fetchTasks is not being used anywhere
export const fetchTasks = (
  setTasks: (data: any[]) => void,
  organization_id: string,
  user: any,
  branchUsers: any[]
) => {
  const subscriber = firestore
    .collection("tasks")
    .where("organization_id", "==", organization_id)
    .onSnapshot((task) => {
      let data: any[] = [];
      if (task) {
        if (user.branchPermission) {
          task.docs.forEach((task) => {
            if (branchUsers.includes(task.data().uid)) {
              data = data.concat(task.data().tasks);
            }
          });
        } else {
          task.docs.forEach((task) => {
            data = data.concat(task.data().tasks);
          });
        }

        data.forEach((task) => {
          if (
            task.status === "Pending" &&
            task.due_date.toDate() < new Date()
          ) {
            task.status = "Overdue";
          }
        });

        setTasks(data);
      } else {
        console.log("org not found");
      }
    });
  return subscriber;
};

export const fetchLeadTasks = (
  setTasks: (data: any[]) => void,
  contactId: string
) => {
  const subscribe = firestore
    .collection("tasks")
    .doc(contactId)
    .onSnapshot((task) => {
      if (task) {
        const data = task.data();
        if (data) {
          setTasks(data.tasks);
        } else {
          setTasks([]);
        }
        console.log("fetchLeadTasks___data",data)
        console.log("fetchLeadTasks___contactId",contactId)
        // console.log("fetchLeadTasks___data",data)
      } else {
        console.log("Contact not Found");
      }
    });
  return subscribe;
};

export const fetchContactResources = (
  setNotes: (data: any[]) => void,
  setAttachments: (data: any[]) => void,
  setCallLogs: (data: any[]) => void,
  contactId: string
) => {
  const subscribe = firestore
    .collection("contactResources")
    .doc(contactId)
    .onSnapshot((resources) => {
      if (resources) {
        const data = resources.data();
        if (data?.notes) {
          setNotes(data.notes);
        } else {
          setNotes([]);
        }
        if (data?.attachments) {
          setAttachments(data.attachments);
        } else {
          setAttachments([]);
        }
        // if (data?.callLogs) {
        //   setCallLogs(data.callLogs);
        // } else {
        //   setCallLogs([]);
        // }
      } else {
        console.log("contact not Found");
      }
    });
  return subscribe;
};

// fetchCallLogs is not being used anywhere
export const fetchCallLogs = (
  setCallList: (data: any[]) => void,
  organization_id: string
) => {
  let callList: any[] = [];
  const subscribe = firestore
    .collection("contactResources")
    .where("organization_id", "==", organization_id)
    .onSnapshot((resources) => {
      resources.docs.forEach((resource) => {
        const data = resource.data();

        if (data?.callLogs) {
          callList.push({
            uid: data.uid,
            data: data.callLogs,
            contactId: resource.id,
          });
        }
      });
      setCallList(callList);
    });
  return subscribe;
};

// fetchUserCallLogs is not being used anywhere
export const fetchUserCallLogs = (
  setCallList: (data: any[]) => void,
  uid: string
) => {
  let callList: any[] = [];
  const subscribe = firestore
    .collection("contactResources")
    .where("uid", "==", uid)
    .onSnapshot((resources) => {
      resources.docs.forEach((resource) => {
        const data = resource.data();

        if (data?.callLogs) {
          callList.push({
            uid: data.uid,
            data: data.callLogs,
            contactId: resource.id,
          });
        }

        setCallList(callList);
      });
    });
  return subscribe;
};


export const fetchProjects = (
  setProjects: (data: any[]) => void,
  organization_id: string
) => {
  const subscriber = firestore
    .collection("organizationResources")
    .doc(organization_id)
    .onSnapshot((projects) => {
      if(organization_id){
        if (projects) {
          const projectData = projects.data();
          if (projectData?.projects) {
            setProjects(projectData?.projects);
          } else {
            setProjects([]);
          }
        } else {
          setProjects([]);
          console.log("Org not found");
        }
      }
    });
    return subscriber;
};

export const deleteProject = async (
  organization_id: string,
  projectList: any[],
  index: number[],
  dispatcher: any,
  setLoad: (data: boolean) => any
) => {

  let data: any[] = [];
  firestore
    .collection("contacts")
    .where("organization_id", "==", organization_id)
    .where("project", "==", "project")
    .get()
    .then((contact) => {
      if (contact) {
        contact.forEach((item) => {
          data.push(item.data());
        });
      }
      
      if (data.length !== 0) {
        dispatcher(
          showSnackbarAction(
            "This Project Is Used In Some Contacts",
            "error"
          )
        );
        setLoad(false);
      } else {
        for (var i = index.length - 1; i >= 0; i--) {
          projectList.splice(index[i], 1);
        }

        try {
          firestore
            .collection("organizationResources")
            .doc(organization_id)
            .set(
              {
                projects: projectList,
              },
              { merge: true }
            );
          dispatcher(
            showSnackbarAction("Project Deleted", "success")
          );
          setLoad(true);
        } catch (e) {
          console.log("Error:", e);
          dispatcher(
            showSnackbarAction("Error! Try Again.", "error")
          );
          setLoad(false);
        }
      }
    });
};

//craeteMultipleProject is not being used anywhere
export const craeteMultipleProject = (
  data: { [key: string]: any }[],
  map: { [key: string]: string },
  organization_id: string,
  dispatcher: any,
  submit: () => void,
  usersList: any[],
  setLoad: (data: boolean) => any
) => { };

export const createProject = (
  organization_id: string,
  project_name: string,
  developer_name: string,
  address: string,
  rera_link: string,
  property_stage: string,
  project_status:string,
  walkthrough_link: string,
  type: string,
  created_by: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => any,
  authToken: any,
  uid: any,
  business_vertical?:any,
) => {
  const doc = firestore
    .collection("projectResources")
    .doc();
  doc.set(
    {
      brochures: [],
      priceLists: [],
      forms: [],
      layouts: [],
      organization_id: organization_id,
    },
    { merge: true }
  );
  firestore
    .collection("organizationResources")
    .doc(organization_id)
    .set(
      {
        organization_id: organization_id,
        projects: Firebase.firestore.FieldValue.arrayUnion({
          project_name: project_name,
          developer_name: developer_name,
          address: address,
          walkthrough_link: walkthrough_link,
          rera_link: rera_link,
          property_type: type,
          property_stage: property_stage,
          project_status:project_status,
          created_at: Firebase.firestore.Timestamp.now(),
          created_by: created_by,
          project_id: doc.id,
          business_vertical:business_vertical
        }),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(
        showSnackbarAction("Project Added", "success")
      );
      setLoad(false);
      history.push("./projects");
    })
    .catch((error) => {
      console.log("Projects Error", error);
      setLoad(false);
    });
};

// changeOwner is not being used now 
export const changeOwner = async (
  selectedOwner: any,
  selectedRowsData: any[],
  dispatcher: any,
  organization_id: string
) => {
  const batch = firestore.batch();

  if (selectedRowsData.length > 500) {
    return false;
  } else {
    selectedRowsData.forEach((item) => {
      const contactsRef = firestore
        .collection("contacts")
        .doc(item.contactId);
      const tasksRef = firestore
        .collection("tasks")
        .doc(item.contactId);
      batch.set(
        contactsRef,
        {
          uid: selectedOwner.uid,
          contact_owner_email:
            selectedOwner.user_email.toLowerCase(),
          lead_assign_time:
            Firebase.firestore.Timestamp.now(),
          modified_at: Firebase.firestore.Timestamp.now(),
          previous_owner: item.contact_owner_email,
          previous_owner_one: item.previous_owner
            ? item.previous_owner
            : "",
        },
        { merge: true }
      );
      batch.set(
        tasksRef,
        {
          uid: selectedOwner.uid,
        },
        { merge: true }
      );
    });

    try {
      await batch.commit();

      let uid = selectedOwner.uid;
      functions.httpsCallable("sendNotifications")(
        JSON.stringify({
          organization_id: organization_id,
          notifications: { [uid]: selectedRowsData.length },
        })
      );
      dispatcher(
        showSnackbarAction("Owner Updated!!", "success")
      );
    } catch (error) {
      console.log("error", error);
      dispatcher(showSnackbarAction("Error!!", "error"));
    }
  }
};

export const  bulkEdit = async (
  changeData: { [key: string]: any },
  selectedRowsData: any[],
  dispatcher: any,
  tasksList:any,
  setLoad: (value: boolean) => void,
  close: () => void,
) => {
  const batch = firestore.batch();

  if (selectedRowsData.length > 500) {
    return false;
  } else {
    selectedRowsData.forEach((item) => {
      const contactsRef = firestore
        .collection("contacts")
        .doc(item.contactId);
        const taskRef = firestore
        .collection("tasks")
        .doc(item.contactId); 
      if(changeData.lost_reason ){

        if (tasksList && tasksList.length !== 0) {
         
          let taskData = {
            status: "INACTIVE",
            tasks: modifyTaskStatus(tasksList),
          };
          batch.update(taskRef, { ...taskData });
        }
        // {changeData.not_int_reason&&changeLeadStage(
        //   item.contactId,
        //   {
        //     not_int_reason: changeData.not_int_reason,
        //     stage: "NOT INTERESTED",
        //     other_not_int_reason: "",
        //   },
        //   (data) => setLoad(data),
        //   dispatcher,
        //   () => {},
        //   // history,
        //   tasksList
        // );}
        changeLeadStage(
          item.contactId,
          {
            lost_reason: changeData.lost_reason,
            stage: "LOST",
            other_lost_reason: "",
          },
          (data) => setLoad(data),
          dispatcher,
          () => {},
          // history,
          tasksList
        );
        batch.set(contactsRef, {...changeData,stage_change_at: Firebase.firestore.Timestamp.now()}, { merge: true });
      }else{
        batch.set(contactsRef, changeData, { merge: true });
      }
    });
    try {
      await batch.commit();
      dispatcher(
        showSnackbarAction("Leads Updated!!", "success")
      );
    } catch (error) {
      console.log("error");
      dispatcher(showSnackbarAction("Error!!", "error"));
    }
  }
};

export const contactResources = (
  organization_id?: string,
  setLocations?: (data: any[]) => void,
  setBudgets?: (data: any[]) => void,
  setLeadSource?: (data: any[]) => void,
  setBusinessVerticalList?: (data: any[]) => void,
  organizationData?: any,
  setFormNamesList?: (data: any[]) => void,
  setState?: (data: any[]) => void,
) => {
  // try {
  //   let apiData: any = {
  //     organization_id: organization_id
  //   };
  //   const res = await axios.get(url + '/projects/fetchAllProjects', {
  //     params: apiData,
  //   });
  //   let projectsData = res.data.data.projectsData;
  //   console.log("aman projects data",projectsData);
  // } catch (err) {
  //   console.log("fetch contact resources error", err);
  // }
  const subscriber = firestore
  .collection("organizationResources")
  .doc(organization_id)
  .onSnapshot((resources) => {
    if (resources) {
      const resourceData = resources.data();
      if (resourceData?.locations) {
        let data: any = [];
        resourceData.locations.forEach((item: any) => {
          data.push(item.location_name);
        });
        setLocations && setLocations(data.sort());
      } else {
        setLocations && setLocations([]);
      }
      if (resourceData?.state) {
        let data: any = [];
        resourceData.state.forEach((item: any) => {
          data.push(item.state_name);
        });
        setState && setState(data.sort());
      } else {
        setState && setState([]);
      }
      if (resourceData?.budgets) {
        let data: any = [];
        resourceData.budgets.forEach((item: any) => {
          data.push(item.budget);
        });

        setBudgets && setBudgets(data.sort());
      } else {
        setBudgets && setBudgets([]);
      }
      if (resourceData?.leadSources) {
        let data: any[] = [];
        resourceData?.leadSources.forEach((item: any) => {
          data.push(item.leadSource);
        });
        setLeadSource && setLeadSource(data.sort());
      } else {
        setLeadSource && setLeadSource([]);
      }
      if (resourceData?.businessVertical) {
        let data: any[] = [];
        resourceData?.businessVertical?.forEach((item: any) => {
          data.push(item);
        });
        setBusinessVerticalList && setBusinessVerticalList(data.sort());
      } else {
        setBusinessVerticalList && setBusinessVerticalList([]);
      }
      if (resourceData?.apiForms) {
        let data: any[] = [];
        resourceData?.apiForms?.forEach((item: any) => {
          data.push(item);
        });
        setFormNamesList && setFormNamesList(data.sort());
      } else {
        setFormNamesList && setFormNamesList([]);
      }
      if (resourceData?.state) {
        let data: any = [];
        resourceData.state.forEach((item: any) => {
          data.push(item.state_name);
        });
        setState && setState(data.sort());
      } else {
        setState && setState([]);
      }
    } else {
      console.log("Org not found");
    }
  });
return subscriber;
};

export const editContact = async (
  contactId: string,
  first_name: string,
  last_name: string,
  contact_no: string,
  alternate_no: string,
  stage: string,
  project: string,
  budget: string,
  location: string,
  property_type: string,
  property_stage: string,
  lead_type: string,
  lead_source: string,
  addset:string,
  campaign:string,
  // not_init_reason: string,
  // other_not_init_reason: string,
  // lost_reason: string,
  // other_lost_reason: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void,
  check: boolean,
  organization_id: string,
  property_sub_type: string,
  country_code: string,
  contactNumberChange: boolean,
  alternateNumberChange: boolean,
  gender?: string,
  marital_status?: string,
  dob?: any,
  anniversary_date?: any,
  address?: any,
  businessVertical?:any,
) => {
  var currentTime = new Date();
  let ab;
  let ad;
  if(dob){
    let Birth_date = new Date(dob)
  Birth_date.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
    ab =Firebase.firestore.Timestamp.fromDate(Birth_date)
  }
    if(anniversary_date){
      let AnniversaryDate = new Date(anniversary_date)
    AnniversaryDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
    ad =Firebase.firestore.Timestamp.fromDate(AnniversaryDate)
    }
  if (check === true) {
    // let result;
    // if (alternate_no !== "") {
    //   const res = await functions.httpsCallable(
    //     "checkLead"
    //   )(
    //     JSON.stringify({
    //       organization_id: organization_id,
    //       contactList: [contact_no, alternate_no],
    //     })
    //   );
    //   result = res;
    // } else {
    //   const res = await functions.httpsCallable(
    //     "checkLead"
    //   )(
    //     JSON.stringify({
    //       organization_id: organization_id,
    //       contact_no: contact_no,
    //     })
    //   );
    //   result = res;
    // }
    let funcData;
    
    if(contactNumberChange && alternateNumberChange){
       funcData = JSON.stringify({
        organization_id: organization_id,
        contactList: [contact_no, alternate_no],
      });
    }
    else if(contactNumberChange){
      funcData = JSON.stringify({
       organization_id: organization_id,
       contact_no: contact_no,
     });
   }
   else if(alternateNumberChange){
    funcData = JSON.stringify({
     organization_id: organization_id,
     contact_no: alternate_no,
   });
  }
    const result = await functions.httpsCallable(
      "checkLead"
    )(funcData);
    if (result.data === false) {
      dispatcher(
        showSnackbarAction(
          // "This Contact Number Already Exists",
          "Contact number or Alternate number already exists on another lead",
          "warning"
        )
      );
      setLoad && setLoad(false);
    } else {
      firestore
        .collection("contacts")
        .doc(contactId)
        .set(
          {
            alternate_no,
            budget,
            contact_no,
            customer_name: first_name + " " + last_name,
            country_code,
            lead_source,
            campaign,
            addset,
            location,
            // lost_reason,
            modified_at: Firebase.firestore.Timestamp.now(),

            // not_init_reason,
            // other_not_init_reason,
            // other_lost_reason,

            project,
            property_stage,
            property_type,
            property_sub_type,
            stage,
            gender,
            marital_status,
            dob:ab ? ab : "",
            anniversary_date:ad ? ad : "",
            address,
            business_vertical:businessVertical
          },
          { merge: true }
        )
        .then(() => {
          dispatcher(
            showSnackbarAction(
              "Record has been updated successfully !",
              "success"
            )
          );
          setLoad(false);

          history.replace("/");
          setTimeout(() => {
            dispatcher(setRefreshContacts(true));
          }, 2500);
        })
        .catch((e) => {
          console.log("Error edit:", e);
          dispatcher(
            showSnackbarAction(
              "Error! Try Again!!",
              "error"
            )
          );
          setLoad(false);
        });
    }
  } else {
    firestore
      .collection("contacts")
      .doc(contactId)
      .set(
        {
          alternate_no,
          budget,
          contact_no,
          customer_name: first_name + " " + last_name,
          country_code,
          lead_source,
          campaign,
          addset,
          location,
          // lost_reason,
          // not_init_reason,
          // other_not_init_reason,
          // other_lost_reason,

          project,
          property_stage,
          lead_type,
          property_type,
          property_sub_type,
          stage,
          gender,
          marital_status,
          dob:ab ? ab : "",   
          anniversary_date:ad ? ad : "",
          address,
          business_vertical:businessVertical
        },
        { merge: true }
      )
      .then(() => {
        dispatcher(
          showSnackbarAction(
            "Contact Details Edited!!",
            "success"
          )
        );
        setLoad(false);

        history.replace("/");
        setTimeout(() => {
          dispatcher(setRefreshContacts(true));
        }, 2500);
      })
      .catch((e) => {
        console.log("Error edit:", e);
        dispatcher(
          showSnackbarAction("Error! Try Again!!", "error")
        );
        setLoad(false);
      });
  }
};

export const fetchConstants = (
  setNotIntReason: (data: any[]) => void,
  setLostReason: (data: any[]) => void,
  // setPropertyStage: (data: any[]) => void,
  // setPropertyType: (data: any[]) => void,
  setFollowUpType?: (data: any[]) => void,
  setCallBack?: (data: any[]) => void,
  setNotIntReasonOther?: (data: any[]) => void,
) => {
  const subscriber = firestore
    .collection("values")
    .doc("constants")
    .onSnapshot((constant) => {
      if (constant) {
        if (constant.data()?.not_interested) {
          setNotIntReason(constant.data()?.not_interested);
        }
        if (constant.data()?.not_interested_other && setNotIntReasonOther) {
          setNotIntReasonOther(constant.data()?.not_interested_other);
        }
        if (constant.data()?.lost_reasons) {
          setLostReason(constant.data()?.lost_reasons);
        }
        // if (constant.data()?.property_stage) {
        //   setPropertyStage(constant.data()?.property_stage.sort());
        // }
        // if (constant.data()?.property_type) {
        //   setPropertyType(constant.data()?.property_type);
        // }
        if (
          constant.data()?.follow_up_type &&
          setFollowUpType
        ) {
          setFollowUpType(constant.data()?.follow_up_type);
        }
        if (constant.data()?.call_back && setCallBack) {
          setCallBack(constant.data()?.call_back);
        }
      }
    });
  return subscriber;
};

// getDataFromRoute not being used anywhere
export const getDataFromRoute = (contacts: any[]) => {
  let data = JSON.parse(JSON.stringify(contacts));
  data.forEach((item: any) => {
    Object.keys(item).forEach((key) => {
      if (datesField.includes(key) && item[key] !== "") {
        item[key] = moment(item[key]);
      }
    });
  });
  return data;
};

// changeDateForRoute not being used anywhere
export const changeDateForRoute = (contacts: any[]) => {
  let data = JSON.parse(JSON.stringify(contacts));

  data.forEach((item: any, index: number) => {
    Object.keys(item).forEach((key) => {
      if (datesField.includes(key) && item[key] !== "") {
        item[key] = contacts[index][key].toDate
          ? contacts[index][key].toDate()
          : "";
      }
    });
  });
  return JSON.stringify(data);
};

export const changeLeadStage = (
  leadId: string,
  leadData: {},
  setLoad: (value: boolean) => void,
  dispatcher: any,
  close: () => void,
  history: any,
  taskList?: any
) => {
  setLoad(true);
  const batch = firestore.batch();
  const taskCollection = firestore
    .collection("tasks")
    .doc(leadId);
  const leadCollection = firestore
    .collection("contacts")
    .doc(leadId);
  batch.update(leadCollection, {
    ...leadData,
    modified_at: Firebase.firestore.Timestamp.now(),
    stage_change_at: Firebase.firestore.Timestamp.now(),
  });

  if (taskList && taskList.length !== 0) {
    let taskData = {
      status: "INACTIVE",
      tasks: modifyTaskStatus(taskList),
    };
    batch.update(taskCollection, { ...taskData });
  }

  batch
    .commit()
    .then(() => {
      setLoad(false);
      dispatcher(
        showSnackbarAction(
          "Lead Status Updated!!",
          "success"
        )
      );
      close();
      // history.push("/");
    })
    .catch((error) => {
      setLoad(false);
      dispatcher(
        showSnackbarAction("Try Again!!", "error")
      );
      console.log("change stage error", error);
      close();
    });
};

export const createTaskFirebase = (
  leadId: string,
  tasks: any[],
  task: any,
  leadDataUpdate: {},
  setLoad: (value: boolean) => any,
  dispatcher: any,
  user: any,
  close: () => void,
  history: any,
  completed?: boolean
) => {
  if (completed === false) tasks = cancelTaskStatus(tasks);
  else tasks = modifyTaskStatus(tasks);
  task = {
    ...task,
    created_at: Firebase.firestore.Timestamp.now(),
    leadId,
    created_by: user.user_email,
  };
  setLoad(true);
  tasks.unshift(task);
  const batch = firestore.batch();
  const taskCollection = firestore
    .collection("tasks")
    .doc(leadId);
  const leadCollection = firestore
    .collection("contacts")
    .doc(leadId);
  batch.set(
    taskCollection,
    {
      status: "ACTIVE",
      tasks,
      uid: user.uid,
      organization_id: user.organization_id,
    },
    { merge: true }
  );
  batch.update(leadCollection, leadDataUpdate);
  batch
    .commit()
    .then(() => {
      setLoad(false);
      dispatcher(
        showSnackbarAction(
          "Lead Status Updated!!",
          "success"
        )
      );
      close();
    })
    .catch((error) => {
      setLoad(false);
      dispatcher(
        showSnackbarAction("Try Again!!", "error")
      );
      console.log("Task Create Error", error);
    });
};

export const reScheduleTaskFirebase = async (
  date: Date,
  tasks: any[],
  leadId: string,
  dispatcher: any,
  history: any
) => {
  let task = { ...tasks[0] };
  task.due_date = date;
  tasks[0] = task;
  try {
    const batch = firestore.batch();
    const taskCollection = firestore
      .collection("tasks")
      .doc(leadId);
    const leadCollection = firestore
      .collection("contacts")
      .doc(leadId);
    batch.set(taskCollection, { tasks }, { merge: true });
    batch.update(leadCollection, {
      next_follow_up_date_time: date,
      modified_at: Firebase.firestore.Timestamp.now(),
    });
    await batch.commit().then(() => {
      dispatcher(
        showSnackbarAction("Task Reshduled!", "success")
      );
      history.push("/");
    });
  } catch (error) {
    dispatcher(showSnackbarAction("Try Again!!", "error"));
    console.log("Reschdule Error", error);
  }
};

export const validateInterested = (
  firstName: string,
  lastName: string,
  propertyType: string,
  propertySubType: string,
  propertyStage: string,
  location: string,
  project: string,
  budget: string,
  followUp: string,
  date: Date,
  leadSource: string,
  alternate: string,
  property_sub_type: string,
  dispatcher: any,
  business_domain:string,
  business_vertical:string,
  state:string,
  is_past_date_approval_enabled:any,
  grace_past_days:any,
  requirement_Type:any,
  display_budget?:any,
) => {
  let previousDateString = getGraceDateForPastApproval(grace_past_days);
  let error = "";
  // console.log("akakaannana",propertySubType,business_domain,requirement_Type)
  if (firstName.length == 0) {
    error = "First Name is required!";
  } else if (lastName.length == 0) {
    error = "Last Name is required!";
  } else if (!requirement_Type || requirement_Type==="Select" || requirement_Type==="") {
    error = "Requirement Type is required!";
  } else if (leadSource === "Select") {
    error = "Lead Source is required!";
  } else if (((propertyType === "Select" || propertyType === "")&&(!business_domain || business_domain== "Real Estate")&&(!requirement_Type || requirement_Type==="NEW PROJECT"))) {
    error = "Property Type is required!";
  } else if (((propertyStage === "Select" || propertyStage === "")&&(!business_domain || business_domain== "Real Estate")&&(!requirement_Type || requirement_Type==="NEW PROJECT"))) {
    error = "Property Stage is required!";
  }
  else if ((business_vertical === "Select"&&(business_domain && business_domain !== "Real Estate"))) {
    error = "Business Vertical is required!";
  }
   else if (location === "Select") {
    error = "Location is required!";
  } else if ((project === "Select" || project === "")&&(!requirement_Type || requirement_Type==="NEW PROJECT")) {
    error = "Project is required!";
  } else if (budget === "Select") {
    error = "Budget is required!";
  } else if (followUp === "Select") {
    error = "Follow Up is required!";
  } else if (!date) {
    error = "Please Enter A Valid Date!!";
  } 
  else if (is_past_date_approval_enabled == true && (new Date(previousDateString) >= new Date(date))) { 
    error = "Date falls out of grace period allowed for updating tasks!";
  }  else if ((is_past_date_approval_enabled == false || is_past_date_approval_enabled == undefined || is_past_date_approval_enabled == null)  && (new Date(date) < new Date())) { 
    error = "Task Cannot be Schedule For Old Date & Time!";
  }
  if (error == "") {
    return {
      budget: budget,
      customer_name: firstName + " " + lastName,
      location: location,
      project: project,
      property_stage: propertyStage==="Select"?"":propertyStage,
      property_type: propertyType==="Select"?"":propertyType,
      property_sub_type: property_sub_type==="Select"?"":property_sub_type,
      stage: "INTERESTED",
      alternate_no: alternate,
      next_follow_up_type: followUp,
      next_follow_up_date_time: moment(date).toDate(),

      // Before Migration

      modified_at: Firebase.firestore.Timestamp.now(),
      stage_change_at: Firebase.firestore.Timestamp.now(),

      // After Migration

      // modified_at: new Date(),
      // stage_change_at: new Date(),
      lead_source: leadSource,
      business_vertical: business_vertical==="Select"?"":business_vertical,
      state:state,
      requirement_Type:requirement_Type,
      display_budget:display_budget
    };
  } else {
    dispatcher(showSnackbarAction(error, "error"));
    return undefined;
  }
};

export const modifyTaskStatus = (tasks: any[]) => {
  if (tasks.length < 1) {
    return tasks;
  }
  let taskData = { ...tasks[0] };
  taskData.status = "Completed";
  taskData = {
    ...taskData,
    completed_at: Firebase.firestore.Timestamp.now(),
  };
  tasks[0] = taskData;
  return tasks;
};

export const cancelTaskStatus = (tasks: any[]) => {
  if (tasks.length < 1) {
    return tasks;
  }
  let taskData = { ...tasks[0] };
  taskData.status = "Cancelled";
  tasks[0] = taskData;
  return tasks;
};

// export const uploadAttachment = async (
//   leadId: string,
//   file: any,
//   attachments: any[],
//   type: string,
//   filename: string,
//   dispatcher: any,
//   setLoad: (data: boolean) => any,
//   close: () => void,
//   authToken?:any,
//   contactDetail?:any,
//   userUid?:any,
// ) => {
//   const path = `${leadId}/${type}/${filename}`;
//   const reference = storage.ref(path);
//   await reference.put(file);
//   const url = await reference.getDownloadURL();
//   const firestoreData = {
//     name: filename,
//     type: type,
//     url: url,
//     created_at: Firebase.firestore.Timestamp.now(),
//   };

//   // const result = await addAttachmentFirestore(
//   //   leadId,
//   //   firestoreData,
//   //   attachments
//   // );
//   const result = await addAttachmentMongo(
//     leadId,
//     firestoreData,
//     authToken,
//     contactDetail,
//     userUid,
//     dispatcher
//   );
//   if (result) {
//     dispatcher(
//       showSnackbarAction(
//         "Uploaded Successfully!",
//         "success"
//       )
//     );
//     setLoad(false);
//     close();
//   } else {
//     dispatcher(
//       showSnackbarAction("Upload Error!!", "error")
//     );
//     setLoad(false);
//     close();
//   }
// };

export const uploadAttachmentToS3 = async (
  file:any, 
  leadId:any,
  dispatcher: any,
  setLoad: (data: boolean) => any,
  close: () => void,
  type?:any,
  authToken?:any,
  contactDetail?:any,
  userUid?:any) => {
  try {
    let url = await uploadFileToS3(file, leadId);

    // console.log("response", response.data);

    const S3Data = {
      name: file.name,
      type: file.type,
      S3url: url,
      created_at: Firebase.firestore.Timestamp.now(),
    };
    await addAttachmentMongo(
      leadId,
      S3Data,
      authToken,
      contactDetail,
      userUid,
      dispatcher,
      close,
      setLoad
    );
    // return response.data.url;
  } catch (error:any) {
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
    close();
  }
};

export const addAttachmentFirestore = async (
  leadId: string,
  data: {},
  attachments: any[]
) => {
  let attachmentsData: any[] = [...attachments];
  attachmentsData.unshift(data);
  try {
    await firestore
      .collection("contactResources")
      .doc(leadId)
      .set(
        {
          attachments: attachmentsData,
        },
        { merge: true }
      );
    return true;
  } catch (error) {
    console.log("attachments firestore", error);
    return false;
  }
};

export const addNoteFirebase = (
  leadId: string,
  notes: any[],
  note: string,
  setLoad: (value: boolean) => void,
  dispatcher: any,
  close?: () => void,
  userEmail?: string
) => {

  if (note.length === 0) {
    dispatcher(
      showSnackbarAction("Please Add A Note", "error")
    );
    return;
  }
  setLoad(true);
  let noteData = [...notes];
  noteData.unshift({
    note: note,
    created_at: Firebase.firestore.Timestamp.now(),
    userEmail: userEmail,
  });
  firestore
    .collection("contactResources")
    .doc(leadId)
    .set(
      {
        notes: noteData,
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction("Saved", "success"));
      setLoad(false);
      close && close();
    })
    .catch((error) => {
      setLoad(false);
      dispatcher(
        showSnackbarAction("Try Again!!", "error")
      );
      console.log("AddNote Error", error);
    });
};

export const fetchpropertySubType = (
  organization_id: string,
  setComTypes: (data: any[]) => void,
  setResTypes: (data: any[]) => void,
  setLeadSource: (data: any[]) => void,
  setIndustrialTypes: (data: any[]) => void,
  setInstitutionalTypes: (data: any[]) => void
) => {
  const subscriber = firestore
    .collection("organizationResources")
    .doc(organization_id)
    .onSnapshot((doc) => {
      const resourceData = doc.data();
      if (resourceData?.comTypes) {
        setComTypes(resourceData?.comTypes);
      } else {
        setComTypes([]);
      }
      if (resourceData?.resTypes) {
        setResTypes(resourceData?.resTypes);
      } else {
        setResTypes([]);
      }
      if (resourceData?.leadSources) {
        let data: any[] = [];
        resourceData?.leadSources.forEach((item: any) => {
          data.push(item.leadSource);
        });
        setLeadSource(data.sort());
      } else {
        setLeadSource([]);
      }
      if (resourceData?.industrialType) {
        setIndustrialTypes(resourceData?.industrialType);
      } else {
        setIndustrialTypes([]);
      }
      if (resourceData?.institutionalType) {
        setInstitutionalTypes(resourceData?.institutionalType);
      } else {
        setInstitutionalTypes([]);
      }
    });

  return subscriber;
};

export const CreateLeadDistribution = (
  organization_id: string,
  leadSourceList: string[],
  projectList: string[],
  locationList: string[],
  budgetList: string[],
  propertyList: string[],
  usersList: any[],
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void,
  apiForms: string[],
) => {
  firestore
    .collection("leadDistribution")
    .doc(organization_id)
    .set(
      {
        organization_id: organization_id,
        logic: Firebase.firestore.FieldValue.arrayUnion({
          source: leadSourceList,
          project: projectList,
          location: locationList,
          budget: budgetList,
          property_type: propertyList,
          api_forms:apiForms,
          users: usersList,
          created_at: Firebase.firestore.Timestamp.now(),
          modify_at: Firebase.firestore.Timestamp.now(),
        }),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(
        showSnackbarAction(
          "Lead Distribution Created!!",
          "success"
        )
      );
      setLoad(false);
      close();
    })
    .catch((error) => {
      console.log(
        "Lead Distribution Created Error:",
        error
      );
      dispatcher(
        showSnackbarAction("Try Again!!", "error")
      );
      setLoad(false);
      close();
    });
};

export const fetchLeadDistributions = (
  organization_id: string,
  setData: (data: any[]) => void
) => {
  const subscribe = firestore
    .collection("leadDistribution")
    .doc(organization_id)
    .onSnapshot((doc) => {
      if (doc) {
        const data = doc.data();
        if (data?.logic) {
          data.logic.forEach((logic: any) => {
            logic.users = logic.users.map(
              (user: any) => user.user_email
            );
          });

          data.logic.forEach((logic: any) => {
            for (const key in logic) {
              // console.log("akzkzkz c",logic[key])
              if (Array.isArray(logic[key]) && key !== "created_at" && key !== "modify_at") {
                logic[key] = logic[key].join(",    ");
              }
            }
          });
          data.logic.forEach((logic: any,index:any) => {
            logic["index"] = index
          });
          setData(data.logic);
        } else {
          setData([]);
        }
      } else {
        setData([]);
      }
    });

  return subscribe;
};

export const fetchLeadDistributionsEdit = (
  organization_id: string,
  setData: (data: any[]) => void
) => {
  const subscribe = firestore
    .collection("leadDistribution")
    .doc(organization_id)
    .onSnapshot((doc) => {
      if (doc) {
        const data = doc.data();
        if (data?.logic) {
          setData(data.logic);
        } else {
          setData([]);
        }
      } else {
        setData([]);
      }
    });

  return subscribe;
};

export const editLeadDistribution = (
  organization_id: string,
  leadDistributionList: any[],
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void,
  user?: any,
  panel?:any,
  authToken?: any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${selectedRows?.length?selectedRows?.length:"1"} lead from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
firestore
.collection("leadDistribution")
.doc(organization_id)
.set(
  {
    logic: leadDistributionList,
  },
  { merge: true }
  )
  .then(() => {
    dispatcher(
      showSnackbarAction(
        "Lead Distribution Updated!!",
        "success"
        )
        );
        // SaveData()
          setLoad(false);
          close();
    })
    .catch((error) => {
      dispatcher(
        showSnackbarAction("Error!! Try Again!!", "error")
      );
      setLoad(false);
      console.log("Upload Error:", error);
    });
};

// Before Migration

// export const uploadContactsFile = async (
//   file: any,
//   organization_id: string,
//   uid: string,
//   dispatcher: any,
//   setLoad: (data: boolean) => void,
//   createdBy: string
// ) => {
//   const doc = firestore
//     .collection("contactsUploadRequest")
//     .doc();
//   const path = `contactsUploadData/${organization_id}/${doc.id}.csv`;
//   const reference = storage.ref(path);

//   try {
//     await reference.put(file);
//     const url = await reference.getDownloadURL();
//     try {
//       await doc.set(
//         {
//           request_id: doc.id,
//           organization_id: organization_id,
//           fileUrl: url,
//           status: "Uploaded",
//           responseURL: "",
//           uploadCount: 0,
//           created_at: Firebase.firestore.Timestamp.now(),
//           created_by: createdBy,
//           uid: uid,
//         },
//         { merge: true }
//       );
//       dispatcher(
//         showSnackbarAction("File Uploaded!!", "success")
//       );
//       setLoad(false);
//     } catch (error) {
//       console.log("Contacts Upload Error", error);
//       dispatcher(
//         showSnackbarAction("Error!! Try Again!!", "error")
//       );
//       setLoad(false);
//     }
//   } catch (error) {
//     console.log("Contacts upload Error", error);
//     dispatcher(
//       showSnackbarAction("Error!! Try Again!!", "error")
//     );
//     setLoad(false);
//   }
// };

export const uploadprojectFile = async (
  file: any,
  organization_id: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  createdBy: string
) => {
  const doc = firestore
    .collection("projectUploadRequest")
    .doc();
  const path = `projectUploadData/${organization_id}/${doc.id}.csv`;
  const reference = storage.ref(path);

  try {

    await reference.put(file);
    const url = await reference.getDownloadURL();
    
    try {
      await doc.set(
        {
          request_id: doc.id,
          organization_id: organization_id,
          fileUrl: url,
          status: "Uploaded",
          responseURL: "",
          uploadCount: 0,
          created_at: Firebase.firestore.Timestamp.now(),
          created_by: createdBy,
        },
        { merge: true }
      );
      dispatcher(
        showSnackbarAction("File Uploaded!!", "success")
      );
      setLoad(false);
    } catch (error) {
      console.log("Project Upload Error", error);
      dispatcher(
        showSnackbarAction("Error!! Try Again!!", "error")
      );
      setLoad(false);
    }
  } catch (error) {
    console.log("Project upload Error", error);
    dispatcher(
      showSnackbarAction("Error!! Try Again!!", "error")
    );
    setLoad(false);
  }
};

export const uploadApiFile = async (
  file: any,
  organization_id: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  createdBy: string
) => {
  const doc = firestore
    .collection("apiUploadRequest")
    .doc();
  const path = `apiUploadData/${organization_id}/${doc.id}.csv`;
  const reference = storage.ref(path);

  try {

    await reference.put(file);
    const url = await reference.getDownloadURL();

    try {
      await doc.set(
        {
          request_id: doc.id,
          organization_id: organization_id,
          fileUrl: url,
          status: "Uploaded",
          responseURL: "",
          uploadCount: 0,
          created_at: Firebase.firestore.Timestamp.now(),
          created_by: createdBy,
        },
        { merge: true }
      );
      dispatcher(
        showSnackbarAction("File Uploaded!!", "success")
      );
      setLoad(false);
    } catch (error) {
      console.log("Api Upload Error", error);
      dispatcher(
        showSnackbarAction("Error!! Try Again!!", "error")
      );
      setLoad(false);
    }
  } catch (error) {
    console.log("Api upload Error", error);
    dispatcher(
      showSnackbarAction("Error!! Try Again!!", "error")
    );
    setLoad(false);
  }
};

// This was running before migration to list imported excel files in contacts

// export const fetchContactsFile = (
//   organization_id: string,
//   uid: string,
//   setUploadFiles: (data: any[]) => void,
//   dispatcher: any
// ) => {
//   const subscriber = firestore
//     .collection("contactsUploadRequest")
//     .where("organization_id", "==", organization_id)
//     .where("uid", "==", uid)
//     .orderBy("created_at", "desc")
//     .limit(25)
//     .onSnapshot((docs) => {
//       if (docs.docs) {
//         docs.docs.forEach((doc) => {
//           const data = doc.data();
//           if (
//             data.status === "Processed" &&
//             data.responseURL === ""
//           ) {
//             const path = `contactsUploadData/${organization_id}/r-${data.request_id}.csv`;
//             const reference = storage.ref(path);

//             reference
//               .getDownloadURL()
//               .then((responseURL) => {
//                 doc.ref.set(
//                   { responseURL },
//                   { merge: true }
//                 );
//               })
//               .then(() => {
//                 dispatcher(
//                   showSnackbarAction(
//                     data.request_id + " File Processed!!",
//                     "success"
//                   )
//                 );
//               });
//           }
//         });
//       }
//       if (docs) {
//         const contactsData: any[] = [];
//         docs.docs.forEach(async (item, index) => {
//           const data = item.data();
//           contactsData.push(data);
//         });
//         setUploadFiles(contactsData);
//       } else {
//         setUploadFiles([]);
//       }
//     });
//   return subscriber;
// };

export const fetchProjectFile = (
  organization_id: string,
  setUploadFiles: (data: any[]) => void,
  dispatcher: any
) => {

  const subscriber = firestore
    .collection("projectUploadRequest")
    .where("organization_id", "==", organization_id)
    .orderBy("created_at", "desc")
    .limit(25)
    .onSnapshot((docs) => {
      if (docs.docs) {
        docs.docs.forEach((doc) => {
          const data = doc.data();
          if (
            data.status === "Processed" &&
            data.responseURL === ""
          ) {

            const path = `projectUploadData/${organization_id}/r-${data.request_id}.csv`;
            const reference = storage.ref(path);
            reference
              .getDownloadURL()
              .then((responseURL) => {
                doc.ref.set(
                  { responseURL },
                  { merge: true }
                );
              })
              .then(() => {
                dispatcher(
                  showSnackbarAction(
                    data.request_id + " File Processed!!",
                    "success"
                  )
                );
              });
          }
        });
      }
      if (docs) {
        const projectData: any[] = [];
        docs.docs.forEach(async (item, index) => {
          const data = item.data();
          projectData.push(data);
        });
        setUploadFiles(projectData);
      } else {
        setUploadFiles([]);
      }
    });
  return subscriber;
};

export const fetchApiFile = (
  organization_id: string,
  setUploadFiles: (data: any[]) => void,
  dispatcher: any
) => {
  const subscriber = firestore
    .collection("apiUploadRequest")
    .where("organization_id", "==", organization_id)
    .orderBy("created_at", "desc")
    .limit(25)
    .onSnapshot((docs) => {
      if (docs.docs) {
        docs.docs.forEach((doc) => {
          const data = doc.data();
          if (
            data.status === "Processed" &&
            data.responseURL === ""
          ) {
            const path = `apiUploadData/${organization_id}/r-${data.request_id}.csv`;
            const reference = storage.ref(path);
            reference
              .getDownloadURL()
              .then((responseURL) => {
                doc.ref.set(
                  { responseURL },
                  { merge: true }
                );
              })
              .then(() => {
                dispatcher(
                  showSnackbarAction(
                    data.request_id + " File Processed!!",
                    "success"
                  )
                );
              });
          }
        });
      }
      if (docs) {
        const apiData: any[] = [];
        docs.docs.forEach(async (item, index) => {
          const data = item.data();
          apiData.push(data);
        });
        setUploadFiles(apiData);
      } else {
        setUploadFiles([]);
      }
    });
  return subscriber;
};


export const toggleis_button_called = async (
  contactId: any
) => {

  await firestore
    .collection("contacts")
    .doc(contactId)
    .update({
      is_button_called: true,
    });
};

export const deleteRecords = (leadIds: any) => {
  const newId: string[] = [];

  leadIds.forEach((element: any) => {

    newId.push(element.contactId);
  });




 try{
  // console.log("amamsksl",newId);
  newId.forEach(async (id: string,index:number) => {
    const contactDoc = await firestore
      .collection("contacts")
      .doc(`${id}`)
      .get();

      const contactDocRef = await firestore
      .collection("contacts")
      .doc(`${id}`)
      // .get();

    const taskDocRef = await firestore
      .collection("tasks")
      .doc(contactDoc.id)
      // .get();
    const resourceDocRef = await firestore
      .collection("contactResources")
      .doc(contactDoc.id)
      // .get();
    await contactDocRef.delete();
    await taskDocRef.delete();
    await resourceDocRef.delete();
  });

  return true;
  // newId.forEach(async (id: string) => {
  //   const doc = await firestore
  //     .collection("tasks")
  //     .doc(`${id}`)
  //     .get();


  //   await doc.ref.delete();



  // });
  // newId.forEach(async (id: string) => {
  //   const doc = await firestore
  //     .collection("contactResources")
  //     .doc(`${id}`)
  //     .get();


  //   await doc.ref.delete();



  // });
 }catch(err){
  console.log(err);
  return false;
 }
};

export const sendVerificationNotification = async (
  organization_id: string,
  uid: string,
  text: string,
) => {
  const funcData = JSON.stringify({
    organization_id: organization_id,
    notifications: {[uid]: text},
  });
  const result = await functions.httpsCallable('sendNotificationsVerification')(funcData);
};

// export const deleteRecords = (newId: any) => {
//  try{
//   newId.forEach(async (id: string,index:number) => {
//     // const contactDoc = await firestore
//     //   .collection("contacts")
//     //   .doc(`${id}`)
//     //   .get();
//       const contactDocRef = await firestore
//       .collection("contacts")
//       .doc(`${id}`)
//       // .get();

//     const taskDocRef = await firestore
//       .collection("tasks")
//       .doc(id)
//       // .get();
//     const resourceDocRef = await firestore
//       .collection("contactResources")
//       .doc(id)
//       // .get();
//       // console.log("amamsksl",contactDocRef.data(), taskDocRef.data() ,resourceDocRef.data() , id,index);
//     await contactDocRef.delete();
//     await taskDocRef.delete();
//     await resourceDocRef.delete();
//   });

//   return true;
//   // newId.forEach(async (id: string) => {
//   //   const doc = await firestore
//   //     .collection("tasks")
//   //     .doc(`${id}`)
//   //     .get();


//   //   await doc.ref.delete();



//   // });
//   // newId.forEach(async (id: string) => {
//   //   const doc = await firestore
//   //     .collection("contactResources")
//   //     .doc(`${id}`)
//   //     .get();


//   //   await doc.ref.delete();



//   // });
//  }catch(err){
//   console.log(err);
//   return false;
//  }
// };

// export const deleteRecords = (leadIds: any) => {
//   const newId: string[] = [];

//   leadIds.forEach((element: any) => {

//     newId.push(element.contactId);
//   });




//   try{
//     newId.forEach(async (id: string) => {
//       const doc = await firestore
//         .collection("contacts")
//         .doc(`${id}`)
//         .get();
  
//       await firestore
//         .collection("tasks")
//         .doc(doc.id)
//         .delete();
//       await firestore
//         .collection("contactResources")
//         .doc(doc.id)
//         .delete();
  
//       await doc.ref.delete();
  
  
  
//     });
//     newId.forEach(async (id: string) => {
//       const doc = await firestore
//         .collection("tasks")
//         .doc(`${id}`)
//         .get();
  
  
//       await doc.ref.delete();
  
  
  
//     });
//     newId.forEach(async (id: string) => {
//       const doc = await firestore
//         .collection("contactResources")
//         .doc(`${id}`)
//         .get();
  
  
//       await doc.ref.delete();
  
  
  
//     });
//     return true;
//   }catch(err){
//     console.log(err);
//   }
// };


// Below this there is all code for migration purpose

export const editLead = async (
  contactId: string,
  first_name: string,
  last_name: string,
  contact_no: string,
  alternate_no: string,
  stage: string,
  project: string,
  budget: string,
  location: string,
  property_type: string,
  property_stage: string,
  lead_type: string,
  lead_source: string,
  addset:string,
  campaign:string,
  // not_init_reason: string,
  // other_not_init_reason: string,
  // lost_reason: string,
  // other_lost_reason: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void,
  check: boolean,
  organization_id: string,
  property_sub_type: string,
  country_code: string,
  contactNumberChange: boolean,
  alternateNumberChange: boolean,
  authToken:any,
  gender?: string,
  marital_status?: string,
  dob?: any,
  anniversary_date?: any,
  address?: any,
  businessVertical?:any,
  state?: string,
  uid?: any,
  unitRef?:any,
  requirement_Type?:any,
  city?: string,
  country?: string,
  display_budget?:any,
) => {
  // console.log("3rnuefnrfnr",country_code)
  let contactNumber=isValidMobile(contact_no,dispatcher);
      if(!contactNumber){
        setLoad(false)
        // history.replace("/")
        return;
      }
  if (check === true) {

    try{
      let funcData="";
    if(contactNumberChange && alternateNumberChange){
       funcData = JSON.stringify({
        organization_id: organization_id,
        contact_no: contact_no,
        alternate_no: alternate_no
      });
    }
    else if(contactNumberChange){
      funcData = JSON.stringify({
       organization_id: organization_id,
       contact_no: contact_no,
     });
   }
   else if(alternateNumberChange){
    funcData = JSON.stringify({
     organization_id: organization_id,
     alternate_no: alternate_no,
   });
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  const leadExistsResponse = await axiosHandler.post(url + '/leads/checkContactExistsNew',JSON.parse(funcData));
  
  if(leadExistsResponse?.data?.leadAlreadyExists){
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        "Contact number or Alternate number already exists on another lead",
        "warning"
      )
    );
    setLoad && setLoad(false);
    return
  }

    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/leads/editLeadNew',     {
      alternate_no,
      budget,
      contact_no,
      customer_name: first_name + " " + last_name,
      country_code,
      lead_source,
      campaign,
      addset,
      location,
      // lost_reason,
      modified_at: Firebase.firestore.Timestamp.now(),
      lead_type,

      // not_init_reason,
      // other_not_init_reason,
      // other_lost_reason,

      project,
      property_stage,
      property_type,
      property_sub_type,
      stage,
      Id:contactId,
      gender: gender,
      marital_status: marital_status,
      dob: dob,
      anniversary_date: anniversary_date,
      address: address,
      business_vertical: businessVertical,
      state,
      unit_no:unitRef,
      requirement_Type:requirement_Type,
      userAuthorizationId: uid,
      city,
      country,
      display_budget
    });

    dispatcher(
      showSnackbarAction(
        "Lead Updated!!",
        "success"
      )
    );
    setLoad(false);
    history.replace("/contacts");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);
    }catch(err:any){
      console.log("Error Updating Lead", err);
          dispatcher(
            showSnackbarAction(
              err.response.data.message ||  "Lead Updation Error",
              "error"
            )
          );
      setLoad(false);
    }
  } else {
    try{
      // console.log("VEEE 3",state)
      // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/leads/editLeadNew',     {
      alternate_no,
      budget,
      contact_no,
      customer_name: first_name + " " + last_name,
      country_code,
      lead_source,
      campaign,
      addset,
      location,
      // lost_reason,
      modified_at: Firebase.firestore.Timestamp.now(),
      lead_type,

      // not_init_reason,
      // other_not_init_reason,
      // other_lost_reason,

      project,
      property_stage,
      property_type,
      property_sub_type,
      stage,
      Id:contactId,
      gender: gender,
      marital_status: marital_status,
      dob: dob,
      anniversary_date: anniversary_date,
      address: address,
      business_vertical: businessVertical,
      state,
      unit_no:unitRef,
      requirement_Type:requirement_Type,
      userAuthorizationId:uid,
      city,
      country,
      display_budget
    });

    dispatcher(
      showSnackbarAction(
        "Lead Updated!!",
        "success"
      )
    );
    setLoad(false);
    history.replace("/contacts");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);
    }catch(err:any){
      console.log("Error Updating Lead", err);
      dispatcher(
        showSnackbarAction(
          err.response.data.message ||  "Lead Updation Error",
          "error"
        )
      );
      setLoad(false);
    }
  }
};

export const createTaskMongo = async (
  leadId: string,
  tasks: any[],
  task: any,
  leadDataUpdate: any,
  setLoad: (value: boolean) => any,
  dispatcher: any,
  user: any,
  close: () => void,
  history: any,
  authToken?:any,
  contactDetail?:any,
  dispositionWhatsappData?: any,
  completed?: boolean,
) => {
  setLoad(true);
  try {
    console.log("gtrvfwcdea 3",leadDataUpdate)
    
    let newTask = {
      ...task,
      created_at: Firebase.firestore.Timestamp.now(),
      leadId,
      created_by: user.user_email,
    };

    let apiData =  {
      leadId: leadId,
      uid: user.uid,
      organization_id: user.organization_id,
      leadData:leadDataUpdate,
      ...newTask,
      completed,
      userAuthorizationId:user.uid
    }
    
    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/tasks/createTaskNew',apiData);

    dispatcher(
      showSnackbarAction(
        "Lead Updated!!",
        "success"
      )
    );
    setLoad(false);
    history.replace("/contacts");

    triggerWhatsappDispositionMessage(
      dispositionWhatsappData.ORGANIZATION_ID,
      dispositionWhatsappData.DISPOSITION,
      dispositionWhatsappData.SUB_DISPOSITION,
      dispositionWhatsappData.LEADID,
      dispositionWhatsappData.UID,
      dispositionWhatsappData.DATE,
      dispositionWhatsappData.PROJECT
    )

    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);

  } catch (error:any) {
    console.log("Lead Updation Error",error);
    dispatcher(
      showSnackbarAction(error.response.data.message || "Lead couldn't be updated", "error")
    );
    setLoad(false);
    history.replace("/contacts");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);
  }
};

export const changeLeadStageMongo = async (
  leadId: string,
  leadData: {},
  setLoad: (value: boolean) => void,
  dispatcher: any,
  close: () => void,
  history: any,
  authToken?:any,
  taskList?: any,
  stage?: any,
  uid?: any,
  dispositionWhatsappData?: any,
) => {
  setLoad(true);
  try {

    let leadDataUpdate = {
      ...leadData,
      modified_at: Firebase.firestore.Timestamp.now(),
      stage_change_at: Firebase.firestore.Timestamp.now(),
    }

    let apiData =  {
      leadId: leadId,
      leadData:leadDataUpdate,
      userAuthorizationId:uid
    }

    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/tasks/changeLeadStageNew',apiData);

    dispatcher(
      showSnackbarAction(
        "Lead Updated!!",
        "success"
      )
    );
    setLoad(false);

    triggerWhatsappDispositionMessage(
      dispositionWhatsappData.ORGANIZATION_ID,
      dispositionWhatsappData.DISPOSITION,
      dispositionWhatsappData.SUB_DISPOSITION,
      dispositionWhatsappData.LEADID,
      dispositionWhatsappData.UID,
      dispositionWhatsappData.DATE
    )

    if(stage !== "WON"){
      history.replace("/contacts");
    }
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);

  } catch (error:any) {
    console.log("Lead Updation Error",error);
    dispatcher(
      showSnackbarAction(error.response.data.message || "Lead couldn't be updated", "error")
    );
    setLoad(false);
  }
};

export const reScheduleTaskMongo = async (
  date: Date,
  tasks: any[],
  leadId: string,
  dispatcher: any,
  history: any,
  authToken?:any,
  uid?:any
) => {
  try {

    let leadDataUpdate = {
      next_follow_up_date_time: date,
      modified_at: Firebase.firestore.Timestamp.now(),
    }

    let apiData =  {
      leadId: leadId,
      leadData:leadDataUpdate,
      date:date,
      userAuthorizationId:uid
    }

    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/tasks/rescheduleTaskNew',apiData);

    dispatcher(
      showSnackbarAction(
        "Lead Updated!!",
        "success"
      )
    );
    history.replace("/contacts");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);

  } catch (error:any) {
    console.log("Lead Updation Error",error);
    dispatcher(
      showSnackbarAction(error.response.data.message || "Lead couldn't be updated", "error")
    );
    // history.replace("/");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);
  }
};

export const fetchLeadTasksMongo = async (
  setTasks: (data: any[]) => void,
  contactId: string,
  authToken?:any,
  dispatcher?:any,
) => {

  try {

    // let apiData =  {
    //   leadId: contactId,
    // }

    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.get(url + '/tasks/getFetchLeadTasksNew',{params:{leadId: contactId}});
    setTasks(res.data?.data)
  } catch (error) {
    setTasks([]);
    // dispatcher(
    //   showSnackbarAction("Lead tasks couldn't be fetched", "error")
    // );
  }
};

export const fetchCallLogsMongo = async (
  setCallLogs: (data: any[]) => void,
  contactId: string,
  authToken?:any,
  dispatcher?:any,
) => {

  try {

    // let apiData =  {
    //   leadId: contactId,
    // }

    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.get(url + '/callLogs/getFetchCallLogsNew',{params:{leadId: contactId}});
    setCallLogs(res.data?.data)
  } catch (error) {
    setCallLogs([]);
  }
};

export const addNoteMongo = async (
  leadId: string,
  notes: any[],
  note: string,
  setLoad: (value: boolean) => void,
  dispatcher: any,
  authToken:any,
  close?: () => void,
  userEmail?: string,
  contactDetail?: any,
  userUid?: any
) => {
  if (note.length === 0) {
    dispatcher(
      showSnackbarAction("Please Add A Note", "error")
    );
    return;
  }
  setLoad(true);

  try {

    let noteData =  {
      note: note,
      created_at: new Date(),
      userEmail: userEmail,
    }
    let apiData = {
      leadId:leadId,
      organization_id:contactDetail.organization_id,
      uid:contactDetail.uid,
      noteData: noteData,
      userAuthorizationId:userUid
    }
    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/contactResourcesMongo/addNote',apiData);

    dispatcher(showSnackbarAction("Saved", "success"));
    setLoad(false);
    close && close();

  } catch (error:any) {
    setLoad(false);
    dispatcher(
      showSnackbarAction(error.response.data.message || "Try Again!!", "error")
    );
    console.log("AddNote Error", error);
  }
};

export const addAttachmentMongo = async (
  leadId: string,
  data: {},
  authToken:any,
  contactDetail?: any,
  userUid?: any,
  dispatcher?: any,
  close?: any,
  setLoad?: any
) => {

  try {
    let apiData = {
      leadId:leadId,
      organization_id:contactDetail.organization_id,
      uid:contactDetail.uid,
      attachmentData: data,
      userAuthorizationId:userUid
    }
    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/contactResourcesMongo/addAttachment',apiData);
    dispatcher(
      showSnackbarAction(
        res.data.message,
        "success"
      )
    );
    setLoad(false);
    close();
  } catch (error:any) {
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
    close();
  }
};

export const fetchContactResourcesMongo = async (
  setNotes: (data: any[]) => void,
  setAttachments: (data: any[]) => void,
  setAudioUrl:(data: any)=>void,
  setImageMGUrl:(data: any)=>void,
  contactId: string,
  authToken?:any,
  dispatcher?:any,
) => {
  try {
    // let apiData =  {
    //   leadId: contactId,
    // }

    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.get(url + '/contactResourcesMongo/getFetchContactResources',{params:{leadId: contactId}});
    setNotes(res.data?.data?.notes)
    let data = res.data?.data?.attachments
    let imageProof
    let callRecording
    let remainingData=[{}]
    data.forEach((item:any) => {
      if (item.name === "Magicleads Gold Image Proof") {
          imageProof = item.url;
      } else if (item.name === "Magicleads Gold Call Recording") {
          callRecording = item.url;
      } else {
          remainingData.push(item);
      }
  });
    setAttachments(remainingData)
    setAudioUrl(callRecording)
    setImageMGUrl(imageProof)
  } catch (error) {
    setNotes([]);
    setAttachments([]);
  }
};

export const isValidMobile = (mobile:any,dispatcher:any) => {
  // Check if the mobile number is numeric and has a length between 10 and 15
  if (!/^\d{7,15}$/.test(mobile)) {
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        "Mobile number is invalid. Please re-enter",
        "error"
      )
    );
      return false ;
  }

  // Check if the mobile number starts with a 0
  if (mobile.startsWith("0")) {
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        "Mobile number should not start with 0. Please re-enter.",
        "error"
      )
    );
      return false;
  }

  return true;
}

export const createLead = async (
  organization_id: string,
  email: string,
  first_name: string,
  last_name: string,
  contact_no: any,
  created_by: string,
  uid: string,
  dispatcher: any,
  history: any,
  user_email: any,
  alternate_no: any,
  country_code: string,
  setLoad: (data: boolean) => any,
  country: string,
  property_type: string,
  property_stage: string,
  lead_type: string,
  location: string,
  budget: string,
  project: string,
  property_sub_type: string,
  leadSource: string,
  addSet:string,
  campaign:string,
  notes: string,
  is_button_called: boolean,
  userEmail?: string,
  authToken?: string,
  gender?: string,
  marital_status?: any,
  dob?: any,
  anniversary?: any,
  cusAdd?: any,
  businessVertical?:any,
  state?: string,
  unit_no?: any,
  requirement_Type?:any,
  city?:string,
  displayBudget?:any
) => {
  try {

    let contactNumber=isValidMobile(contact_no,dispatcher);
      if(!contactNumber){
        setLoad(false)
        // history.replace("/")
        return;
      }
    let apiData;
    // axios.defaults.headers.common['x-access-token'] = authToken
    const leadExistsResponse = await axiosHandler.post(url + '/leads/checkContactExistsNew',     {
      alternate_no: alternate_no,
      organization_id: organization_id,
      contact_no:contact_no,
    });
    
    if(leadExistsResponse?.data?.leadAlreadyExists){
      dispatcher(
        showSnackbarAction(
          // "This Contact Number Already Exists",
          "Contact number or Alternate number already exists on another lead",
          "warning"
        )
      );
      setLoad && setLoad(false);
      return
    }

    if (notes !== "") {
      apiData = {
        alternate_no: alternate_no,
        organization_id: organization_id,
        associate_status: true,
        budget: budget,
        contact_no: contact_no,
        country_code: country_code,
        created_at: Firebase.firestore.Timestamp.now(),
        created_by: created_by,
        customer_image: "",
        customer_name: first_name + " " + last_name,
        email: email.toLowerCase(),
        lead_source: leadSource,
        lead_assign_time: Firebase.firestore.Timestamp.now(),
        location: location,
        lost_reason: "",
        modified_at: Firebase.firestore.Timestamp.now(),
        not_int_reason: "",
        other_not_int_reason: "",
        other_lost_reason: "",
        previous_owner: "",
        project: project,
        property_stage: property_stage,
        property_type: property_type,
        property_sub_type: property_sub_type,
        source_status: true,
        stage: "FRESH",
        transfer_status: false,
        uid: uid,
        lead_type:lead_type,
        contact_owner_email: user_email.toLowerCase(),
        feedback_time: "",
        next_follow_up_type: "",
        next_follow_up_date_time: "",
        is_button_called: false,
        addset:addSet,
        campaign:campaign,
        noteData:{
          note: notes,
          created_at: new Date(),
          userEmail: userEmail,
        },
        gender: gender,
        marital_status: marital_status,
        dob: dob,
        anniversary_date: anniversary,
        address: cusAdd,
        business_vertical: businessVertical,
        state: state,
        unit_no:unit_no,
        requirement_Type:requirement_Type,
        city:city,
        country:country,
        displayBudget:displayBudget
      }
    }else{
      apiData = {
        alternate_no: alternate_no,
        organization_id: organization_id,
        associate_status: true,
        budget: budget,
        contact_no:contact_no,
        country_code: country_code,
        created_at: Firebase.firestore.Timestamp.now(),
        created_by: created_by,
        customer_image: "",
        customer_name: first_name + " " + last_name,
        email: email.toLowerCase(),
        lead_source: leadSource,
        lead_assign_time: Firebase.firestore.Timestamp.now(),
        location: location,
        lost_reason: "",
        modified_at: Firebase.firestore.Timestamp.now(),
        not_int_reason: "",
        other_not_int_reason: "",
        other_lost_reason: "",
        previous_owner: "",
        project: project,
        property_stage: property_stage,
        property_type: property_type,
        property_sub_type: property_sub_type,
        source_status: true,
        stage: "FRESH",
        transfer_status: false,
        uid: uid,
        lead_type:lead_type,
        contact_owner_email: user_email.toLowerCase(),
        feedback_time: "",
        next_follow_up_type: "",
        next_follow_up_date_time: "",
        is_button_called: false,
        addset:addSet,
        campaign:campaign,
        gender: gender,
        marital_status: marital_status,
        dob: dob,
        anniversary_date: anniversary,
        address: cusAdd,
        business_vertical: businessVertical,
        state: state,
        unit_no:unit_no,
        requirement_Type:requirement_Type,
        userAuthorizationId:uid,
        city:city,
        country:country,
        displayBudget:displayBudget
      }
    }
    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/leads/createLeadNew',apiData );
    sendNotification(organization_id, uid,'New Leads', '1 lead assigned',{},authToken);
    // functions.httpsCallable("sendNotifications")(
    //   JSON.stringify({
    //     organization_id: organization_id,
    //     notifications: { [uid]: 1 },
    //   })
    // );

    dispatcher(
      showSnackbarAction(
        "Lead Created!!",
        "success"
      )
    );
    setLoad(false);
    history.replace("/contacts");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);

  } catch (error:any) {
    console.log("Lead Creation Error",error);
    dispatcher(
      showSnackbarAction(error.response.data.message || "Lead couldn't be added", "error")
    );
    setLoad(false);
  }
};

export const  bulkEditMongo = async (
  changeData: { [key: string]: any },
  selectedRowsData: any[],
  dispatcher: any,
  tasksList:any,
  setLoad: (value: boolean) => void,
  close: () => void,
  history?:any,
  authToken?:any,
  uid?:any
) => {
  if (selectedRowsData.length > 500) {
    return false;
  } else {
    try{
      let leadIds:any = [];
      selectedRowsData.map(item => {
        leadIds.push(item?.contactId);
      })
      let apiData = {
        changeData:changeData,
        leadIds:leadIds,
        userAuthorizationId:uid
      }
      // axios.defaults.headers.common['x-access-token'] = authToken
      const res = await axiosHandler.post(url + '/leads/bulkUpdateLeads',apiData );

        dispatcher(
          showSnackbarAction("Leads Updated!!", "success")
        );
        setLoad(false);
        // history.push("/tasks");
        close();
        setTimeout(() => {
          dispatcher(setRefreshContacts(true));
        }, 2500);
        window.location.reload();
      
    }catch(error:any){
      console.log("error");
      dispatcher(showSnackbarAction(error.response.data.message ||"Error!!", "error"));
      setLoad(false);
      // setTimeout(() => {
      //   dispatcher(setRefreshContacts(true));
      // }, 2500);
      // close();
    }
  }
};

export const  transferLeads = async (
  data:any,setLoad:any,close:any,clearSelectedRowsData:any,dispatcher:any,userEmail:any,authToken:any,uid?:any
) => {
  try{
    // axios.defaults.headers.common['x-access-token'] = authToken
    const leadExistsResponse = await axiosHandler.post(url + '/leads/transferLeadsNew',     {
      ...data,
      requestUserEmail:userEmail,
      userAuthorizationId:uid
    });
      dispatcher(
        showSnackbarAction("Owner Updated!!", "success")
      );
      setLoad(false);
    close();
    clearSelectedRowsData && clearSelectedRowsData();
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);
    window.location.reload();
  }catch(error:any){
    console.log("owner change error:", error);
    dispatcher(
      showSnackbarAction(error.response.data.message ||"An Error Occured", "error")
    );
    setLoad(false);
  }
};

// After Migration

export const uploadContactsFile = async (
  file: any,
  organization_id: string,
  uid: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  createdBy: string
) => {
  const doc = firestore
    .collection("contactsUploadRequest")
    .doc();
  const path = `contactsUploadData/${organization_id}/${doc.id}.csv`;
  const reference = storage.ref(path);

  try {
    await reference.put(file);
    const url = await reference.getDownloadURL();
    try {
      await doc.set(
        {
          request_id: doc.id,
          organization_id: organization_id,
          fileUrl: url,
          status: "Uploaded",
          responseURL: "",
          uploadCount: 0,
          created_at: Firebase.firestore.Timestamp.now(),
          created_by: createdBy,
          uid: uid,
        },
        { merge: true }
      );
      dispatcher(
        showSnackbarAction("File Uploaded!!", "success")
      );
      setLoad(false);
    } catch (error) {
      console.log("Contacts Upload Error", error);
      dispatcher(
        showSnackbarAction("Error!! Try Again!!", "error")
      );
      setLoad(false);
    }
  } catch (error) {
    console.log("Contacts upload Error", error);
    dispatcher(
      showSnackbarAction("Error!! Try Again!!", "error")
    );
    setLoad(false);
  }
};

export const uploadContactsFileToMongo = async (
  fileUrl: string,
  organization_id: string,
  uid: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken: any,
  request_id: any
) => {

  try {
    
    let apiData = {
      fileUrl,
      organization_id,
      created_by:uid,
      uid:uid,
      request_id
    }
    // axios.defaults.headers.common['x-access-token'] = authToken;
    let res = await axiosHandler.post(url + '/dataUploadRequest/uploadContacts', apiData);
    dispatcher(
      showSnackbarAction(res.data.message, "success")
    );
    setLoad(false);
    window.location.reload();
  } catch (error:any) {
    throw error;
  }
};

export const fetchContactsFileFromMongo = async (
  organization_id: string,
  uid: string,
  type: string,
  setUploadFiles: (data: any[]) => void,
  // dispatcher: any,
  // authToken: any
) => {
  try {
    let apiData: any = {
      organization_id,
      uid,
      type
    };
    const res:any = await axiosHandler.get(url + '/dataUploadRequest/fetchAll', {
      params: apiData,
    });
    setUploadFiles(res.data.data);

    // if (data) {
    //   setUploadFiles(data.data);
    // } else {
    //   setUploadFiles([]);
    // }
  } catch (error) {
    console.log("Contacts fetch Error", error);
    setUploadFiles([]);
  }
};

// This is running after migration to list imported excel files in contacts

export const fetchContactsFile = (
  organization_id: string,
  uid: string,
  setUploadFiles: (data: any[]) => void,
  dispatcher: any
) => {
  const subscriber = firestore
    // .collection("contactsUploadRequestTest")
    .collection("contactsUploadRequest")
    .where("organization_id", "==", organization_id)
    .where("uid", "==", uid)
    .orderBy("created_at", "desc")
    .limit(25)
    .onSnapshot((docs) => {
      if (docs.docs) {
        docs.docs.forEach((doc) => {
          const data = doc.data();
          if (
            data.status === "Processed" &&
            data.responseURL === ""
          ) {
            // const path = `contactsUploadDataTest/${organization_id}/r-${data.request_id}.csv`;
            const path = `contactsUploadData/${organization_id}/r-${data.request_id}.csv`;
            const reference = storage.ref(path);

            reference
              .getDownloadURL()
              .then((responseURL) => {
                doc.ref.set(
                  { responseURL },
                  { merge: true }
                );
              })
              .then(() => {
                dispatcher(
                  showSnackbarAction(
                    data.request_id + " File Processed!!",
                    "success"
                  )
                );
              });
          }
        });
      }
      if (docs) {
        const contactsData: any[] = [];
        docs.docs.forEach(async (item, index) => {
          const data = item.data();
          contactsData.push(data);
        });
        setUploadFiles(contactsData);
      } else {
        setUploadFiles([]);
      }
    });
  return subscriber;
};

export const deleteProjectMongo = async (
  organization_id: string,
  projectList: any[],
  index: number[],
  dispatcher: any,
  setLoad: (data: boolean) => any,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
  const SaveData = async () => {
    try {
      let res = await axiosHandler.post(url+'/auditLogs/createExportLogs', {
      uid:user.uid?user.uid:"",
      user_email:user.user_email?user.user_email:"",
      user_first_name:user.user_first_name?user.user_first_name:"",
      user_last_name:user.user_last_name?user.user_last_name:"",
      total_count:selectedRows?.length?selectedRows?.length:"",
      type:panel?panel:"",
      organization_id:user.organization_id?user.organization_id:"",
      operation_type:"Delete",
      description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${selectedRows?.length?selectedRows?.length:""} records from ${panel?panel:""} panel.`
      })
      console.log("Delete Log Saved Successfully");
    } catch (error) {
      console.log(error,"Delete Log Couldn't Be Saved");
    }
}
  try {

    let data: any[] = [];

    let apiData =  {
      organization_id: organization_id,
      project:"project"
    }

    // axios.defaults.headers.common['x-access-token'] = authToken
    let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

    if (res) {
      res.data.data.forEach((item:any) => {
        data.push(item);
      });
    }
    
    if (data.length !== 0) {
      dispatcher(
        showSnackbarAction(
          "This Project Is Used In Some Contacts",
          "error"
        )
      );
      setLoad(false);
    } else {
      for (var i = index.length - 1; i >= 0; i--) {
        projectList.splice(index[i], 1);
      }

      try {
        firestore
          .collection("organizationResources")
          .doc(organization_id)
          .set(
            {
              projects: projectList,
            },
            { merge: true }
          );
        dispatcher(
          showSnackbarAction("Project Deleted", "success")
        );
            SaveData()
        setLoad(true);
      } catch (e) {
        console.log("Error:", e);
        dispatcher(
          showSnackbarAction("Error! Try Again.", "error")
        );
        setLoad(false);
      }
    }

  } catch (error) {
    console.log("Error:", error);
    dispatcher(
      showSnackbarAction("Error! Try Again.", "error")
    );
    setLoad(false);
  }
};

// after migration the lead Distribution from firebase to mongodb 


export const filterValuesLeadDistribution=async(
  organization_id:any,
  authToken:any,
  dispatcher:any,
)=>{
   try {
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.get(url + '/leadDistribution/filterValues', { params: { organization_id: organization_id}});
     let data:any=res.data.data[0];
    //  console.log("frfnrur",data)
     dispatcher(setFilterObject({...data}));
   } catch (error) {
       dispatcher(setFilterObject({}))
   }
}

export const createLeadDistributionNew= async(
  organization_id: string,
  leadSourceList: string[],
  projectList: string[],
  locationList: string[],
  budgetList: string[],
  propertyList: string[],
  usersList: any[],
  requirement:string[],
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void,
  apiForms: string[],
  authToken:any,
  toggleAutoLeadRotation?:any,
  timeRef?:any,
  lastLeadAssigne?:any
)=>{

  try {

    let apiData={
      organization_id:organization_id,
      budget:budgetList,
      project:projectList,
      location:locationList,
      source:leadSourceList,
      property_type:propertyList,
      users:usersList,
      requirement_type:requirement,
      api_forms:apiForms,
      autoRotationalEnable:toggleAutoLeadRotation,
      autoRotationTime:timeRef,
      returnLeadTo:lastLeadAssigne
    }

    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.post(url + '/leadDistribution/create',apiData);
    let message=res.data.message
    if(res.data.success === false){
      dispatcher(
        showSnackbarAction(
          message,
          "error"
        )
      );
      setLoad(false);
    }
    else{
      setLoad(false);
      close();
      dispatcher(
        showSnackbarAction(
          message,
          "success"
        )
      ); 

      setTimeout(() => {
        window.location.reload();
      }, 1000); 
    }
  } catch (error) {
    console.log(
      "Lead Distribution Created Error:",
      error
    );
    dispatcher(
      showSnackbarAction("Try Again!!", "error")
    );
    setLoad(false);
    close();
    
  }

}

export const editLeadDistributionNew= async(
  Id:any,
  organization_id:any,
  leadSourceList: string[],
  projectList: string[],
  locationList: string[],
  budgetList: string[],
  propertyList: string[],
  usersList: any[],
  requirement: string[],
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void,
  apiForms: string[],
  authToken:any,
  toggleAutoLeadRotation?:any,
  timeRef?:any,
  leadAssigne?:any
)=>{

  try {
    let apiData={
      Id:Id,
      budget:budgetList,
      project:projectList,
      location:locationList,
      source:leadSourceList,
      property_type:propertyList,
      users:usersList,
      requirement_type:requirement,
      api_forms:apiForms,
      autoRotationEnabled:toggleAutoLeadRotation,
      autoRotationTime:timeRef,
      returnLeadTo:leadAssigne
    }
    // console.log("apiData",apiData);
    
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.put(url + '/leadDistribution/update',apiData);
    console.log("ferf",res);
    if(res.data.success === false){
      dispatcher(
        showSnackbarAction(
          res.data.error,
          "error"
        )
      );
      setLoad(false);
    }
    else{
        // SaveData()
          setLoad(false);
          close();
          dispatcher(
            showSnackbarAction(
              res.data.message,
              "success"
              )
              );
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
  } catch (error) {
    dispatcher(
      showSnackbarAction("Error!! Try Again!!", "error")
    );
    setLoad(false);
    console.log("Upload Error:", error);
  }

   

}

export const deleteLeadDistributionNew = async (
  Id: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void,
  authToken: any
) => {
  try {
    // axios.defaults.headers.common['x-access-token'] = authToken;

    const res = await axiosHandler.post(url + '/leadDistribution/delete', { Id:Id});

    setLoad(false);
    close();
    dispatcher(
      showSnackbarAction(res.data.message, "success")
    );

    // Introduce a delay of one second before reloading the window
    setTimeout(() => {
      window.location.reload();
    }, 1000);

  } catch (error) {
    dispatcher(
      showSnackbarAction("Error!! Try Again!!", "error")
    );
    setLoad(false);
    console.log("Upload Error:", error);
  }
};


export const countleadDistributionNew= async(
   organization_id:any,
   setLoad: (data: boolean) => void,
   authToken:any,
   dispatcher:any,
   setData: (data: any[]) => void,
   filter:string
)=>{
  try {
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.get(url + '/leadDistribution/count', { params: { organization_id: organization_id,filters:filter}});
    
    setData(res.data.data);
    setLoad(false);
  } catch (error) {
    setLoad(false);
    console.log("error",error)
  }

}

export const contactResourcesMongo = async (
  organization_id?: string,
  setProjects?: (data: any[]) => void,
  setProjectDeveloperObj?: (data: any[]) => void,
  organizationData?: any,
) => {
  try {
    let apiData: any = {
      organization_id: organization_id
    };
    const res = await axiosHandler.get(url + '/projects/fetchAllProjects', {
      params: apiData,
    });
    let projectsData = res.data.data;
    if (projectsData.length > 0) {
      let data: any = [];
      let prodevData: any = [];
      if (!organizationData.business_domain || organizationData.business_domain == "Real Estate") {
        projectsData.forEach((item: any) => {
          data.push(item.project_name);
        });
        setProjects && setProjects(data.sort());
        projectsData.forEach((item: any) => {
          prodevData.push({ "project_name": item.project_name, "developer_name": item.developer_name });
        });
        setProjectDeveloperObj && setProjectDeveloperObj(prodevData)
      } else {
        projectsData.forEach((item: any) => {
          data.push(item.project_name);
        });
        setProjects && setProjects(data.sort());
        setProjectDeveloperObj && setProjectDeveloperObj([])
      }
    } else {
      setProjectDeveloperObj && setProjectDeveloperObj([]);
      setProjects && setProjects([]);
    }
  } catch (err) {
    console.log("fetch contact resources error", err);
  }
};

export const createTaskMongoAndApproval = async (
  leadId: string,
  tasks: any[],
  task: any,
  leadDataUpdate: any,
  setLoad: (value: boolean) => any,
  dispatcher: any,
  user: any,
  close: () => void,
  history: any,
  authToken?:any,
  contactDetail?:any,
  completed?: boolean,
  reportingToUser?:any,
  dispositionWhatsappData?: any,
) => {
  setLoad(true);
  try {
    
    let newTask = {
      ...task,
      created_at: Firebase.firestore.Timestamp.now(),
      leadId,
      created_by: user.user_email,
    };

    let apiData =  {
      leadId: leadId,
      uid: user.uid,
      organization_id: user.organization_id,
      leadData:leadDataUpdate,
      ...newTask,
      completed,
      userAuthorizationId:user.uid,
      reportingToUser,
      user
    }

    // console.log("edeu",apiData)
    
    // axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axiosHandler.post(url + '/tasks/createTaskNewAndApproval',apiData);

    dispatcher(
      showSnackbarAction(
       res.data.message,
        "success"
      )
    );
    setLoad(false);

    
    triggerWhatsappDispositionMessage(
      dispositionWhatsappData.ORGANIZATION_ID,
      dispositionWhatsappData.DISPOSITION,
      dispositionWhatsappData.SUB_DISPOSITION,
      dispositionWhatsappData.LEADID,
      dispositionWhatsappData.UID,
      dispositionWhatsappData.DATE,
      dispositionWhatsappData.PROJECT,
    )

   if(Object.keys(res.data.data).length!==0){
    history.replace("/contacts");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);
   }

  } catch (error:any) {
    console.log("Lead Updation Error",error);
    dispatcher(
      showSnackbarAction(error.response.data.message || "Lead couldn't be updated", "error")
    );
    setLoad(false);
    history.replace("/contacts");
    setTimeout(() => {
      dispatcher(setRefreshContacts(true));
    }, 2500);
  }
};

export const fetchSingleMBData = async (leadId: string) => {
  try {

      // let authToken = await firestore().collection('values').doc('constants').get();
      // let AUTHTOKEN = authToken.data()?.authToken ? authToken.data()?.authToken : "";

      let apiData =  {
        contact_id: leadId
      }
    const backendUrl = url + '/leads/fetchLeadByMBContactId';

    const res = await axiosHandler.get(backendUrl, {params:apiData})


      return res.data.data


  } catch (error) {

    console.log('Lead fetching error', error);
    return {};
  }
};


export const softDeleteContacts = async (leadIds: any,
  setLoad: (value: boolean) => any,
  close: () => void,
  dispatcher: any,
  clearSelectedRowsData:any
) => {
  let res:any;
  try {

      // let authToken = await firestore().collection('values').doc('constants').get();
      // let AUTHTOKEN = authToken.data()?.authToken ? authToken.data()?.authToken : "";
    //  console.log("leadIds",leadIds)
    //   const modiData:any=leadIds.map((val:any)=>val.contactId)

      let apiData =  {
        leadIds: leadIds
      }
    const backendUrl = url + '/restoringLeads/deletedLogs';

    res = await axiosHandler.post(backendUrl, apiData)

 if (res?.data?.success === true) {
        setTimeout(() => {
          close();
          setLoad(false);
          dispatcher(showSnackbarAction(res?.data?.message, "success"));
          clearSelectedRowsData && clearSelectedRowsData();
        }, 2500);
        window.location.reload();
      } else {
        setTimeout(() => {
          close();
          setLoad(false);
          dispatcher(showSnackbarAction(res?.data?.message, "error"));
          clearSelectedRowsData && clearSelectedRowsData();
        }, 2500);
      }
      return true 


  } catch (error:any) {

    console.log('Lead fetching error', error);
    setTimeout(() => {
      close();
      setLoad(false);
      dispatcher(showSnackbarAction(error?.response?.data?.message || "Failed to delete records", "error"));
      clearSelectedRowsData && clearSelectedRowsData();
    }, 2500);
    return false
  }
};

export const restoreDataContacts = async (leadIds: any,
  setLoad: (value: boolean) => any,
  close: () => void,
  dispatcher: any,
  clearSelectedRowsData:any
) => {
  let res:any;
  try {

      // let authToken = await firestore().collection('values').doc('constants').get();
      // let AUTHTOKEN = authToken.data()?.authToken ? authToken.data()?.authToken : "";
    //  console.log("leadIds",leadIds)
    //   const modiData:any=leadIds.map((val:any)=>val.contactId)

      let apiData =  {
        leadIds: leadIds
      }
    const backendUrl = url + '/restoringLeads/restoreLeads';

    res = await axiosHandler.post(backendUrl, apiData)

 if (res?.data?.success === true) {
        setTimeout(() => {
          close();
          setLoad(false);
          dispatcher(showSnackbarAction(res?.data?.message, "success"));
          clearSelectedRowsData && clearSelectedRowsData();
        }, 2500);
        window.location.reload();
      } else {
        setTimeout(() => {
          close();
          setLoad(false);
          dispatcher(showSnackbarAction(res?.data?.message, "error"));
          clearSelectedRowsData && clearSelectedRowsData();
        }, 2500);
      }
      return true 


  } catch (error:any) {

    console.log('Lead fetching error', error);
    setTimeout(() => {
      close();
      setLoad(false);
      dispatcher(showSnackbarAction(error?.response?.data?.message || "Failed to delete records", "error"));
      clearSelectedRowsData && clearSelectedRowsData();
    }, 2500);
    return false
  }
};


export const getDeletedContactsFilter = async (dispatcher:any,user:any,booleanObject:any) => {
    // axios.defaults.headers.common["x-access-token"] =
    //   authToken
   try {
    const res = await axiosHandler.get(url + "/restoringLeads/filterValues", {
      params: { uid: user.uid }
    });
    const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
      organization_id: user.organization_id,
      uid: user.uid
    });
 console.log("res.data.data",res.data.data[0])
    if (res.data.data[0]) {
      dispatcher(
        setFilterObject({
          ...res.data.data[0],
          'lead_type': ['Data', 'Leads'],
          'employee_name': userdetail.data.data.Employee_Name,
          'employee_id': userdetail.data.data.Employee_id,
          ...booleanObject,
          status: ["Pending", "Cancelled", "Completed"],
          type: ["Meeting", "Site Visit", "Call Back"]
        })
      );
    } else {
      dispatcher(setFilterObject({}));
    }
   } catch (error) {
    dispatcher(setFilterObject({}));
   }
  };
  
export const fetchBoosterLeadsCount = async (organization_id: string) => {
  try {
    let apiData = {
      organization_id: organization_id,
      booster_type: "Masked Booster Leads"
    }
    const backendUrl = url + '/leads/getBoosterLeadsCount';
    const res = await axiosHandler.get(backendUrl, { params: apiData })
    return res.data.data.boosterLeadsCount;
  } catch (error) {
    return 0;
  }
};



export const maskedBossterMonthWise= async()=>{
 try {
   const res = await axiosHandler.get(url + '/leads/monthWiseAggregateCountOfBoosterLeads');

   return res 
   
 } catch (error) {
   
   console.log("error",error)

   return {}
 }

}

